// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:14:17.265Z
// Property: Bay Vista Apartments (ID: 6737460151192622)
// Collections: 25 amenities, 36 floorplans (live), 40 photos, 37 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151192622",
  "property_external_id": "4687858",
  "property_zillow_url": "https://www.zillow.com/apartments/corpus-christi-tx/bay-vista/5XhsvY/",
  "property_apartments_url": "https://www.apartments.com/bay-vista-corpus-christi-tx/mfbtzdh",
  "property_google_business_url": "https://www.google.com/maps/place/Bay+Vista/data=!4m2!3m1!1s0x0:0x539fadd96abef507?sa=X&ved=2ahUKEwjM-4WBxLySAxWiRjABHS-vFEoQ_BJ6BAg7EAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321182085",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "bay-vista-apartments",
  "property_name": "Bay Vista Apartments",
  "property_website_url": "https://www.bayvistaliving.com/",
  "property_domain": "https://www.bayvistaliving.com/",
  "property_address": "522 Hancock Ave",
  "property_full_address": "522 Hancock Ave, Corpus Christi, TX 78404",
  "property_address_1": "522 Hancock Ave",
  "property_address_2": null,
  "property_address_city": "Corpus Christi",
  "property_address_state": "TX",
  "property_address_zip_full": "78404-2342",
  "property_address_zip": "78404",
  "property_address_country": "US",
  "property_address_county": "Nueces County",
  "property_neighborhood_address": "Central City",
  "property_address_latitude": "27.7828863",
  "property_address_longitude": "-97.3963942",
  "property_email": "bayvista@rreafresidential.com",
  "property_phone": "(361) 882-7766",
  "property_call_tracking_phone": "361-304-3901",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Bay Vista Apartments in beautiful Corpus Christi, TX, where your ideal living space awaits! Choose from spacious floor plans, including studio, one, and two-bedroom options. Enjoy top-notch amenities like our pet-friendly parks, 24/7 maintenance, and eco-friendly recycling. Elevate your lifestyle—schedule a tour today!",
  "property_long_description": "Welcome to Bay Vista Apartments, your ideal living destination in beautiful Corpus Christi, TX! Offering an array of spacious floor plans, our community features one-bedroom, two-bedroom, and studio apartments designed to fit your unique lifestyle. With pet-friendly options and an on-site dog park, your furry friends will love it here just as much as you will!\n\nAt Bay Vista, we prioritize your comfort and convenience. Enjoy peace of mind with our 24-hour on-call maintenance, night patrol for added security, and an online resident services portal that makes managing your home a breeze. We’ve got all the amenities you need, including a fully-equipped TV lounge for relaxation, a garage for hassle-free parking, and ample storage space for your belongings. Plus, our flexible short-term lease options provide the perfect living solution for those with changing needs.\n\nWe're proud to promote a sustainable lifestyle with our recycling program, ensuring that residents can contribute to a greener community. With a pet park and various outdoor spaces, residents can unwind and enjoy the beautiful Corpus Christi weather right outside their door. Don’t forget about our resident referral program, where you can earn rewards for helping friends find their new homes!\n\nBay Vista Apartments is committed to providing an exceptional living experience. Find your new home today—browse our availability or schedule a tour to visit our community and see firsthand what makes us a price leader in the area! Your perfect apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e1e00-4de6-709b-ae41-0309f862f1ec.webp",
  "property_featured_image_media": {
    "alt_text": "Luxury swimming pool and apartment building exterior.",
    "public_id": "019e1e00-4de6-709b-ae41-0309f862f1ec",
    "storage_key": "property/6737460151192622/019e1e00-4de6-709b-ae41-0309f862f1ec.webp",
    "width": 1920,
    "height": 1280
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "333",
  "property_year_built": "2008",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "87.68768768768768",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "250",
  "property_pet_deposit": "1000",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "70",
  "property_pet_restrictions": "null",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://bayvistaliving.loftliving.com/login",
  "property_apply_now_url": "https://8346183.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e1e00-6c76-71cf-a2d2-59264e4708ab.webp",
  "property_primary_logo_media": {
    "alt_text": "Bay Vista Apartments logo with a stylized palm tree and diamond shape.",
    "public_id": "019e1e00-6c76-71cf-a2d2-59264e4708ab",
    "storage_key": "property/6737460151192622/019e1e00-6c76-71cf-a2d2-59264e4708ab.webp",
    "width": 750,
    "height": 300
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e1e00-6c9a-74d1-95bf-5ae4ff305249.webp",
  "property_secondary_logo_media": {
    "alt_text": "Bay Vista Apartments logo with a palm tree silhouette inside a diamond shape with a sunset gradient.",
    "public_id": "019e1e00-6c9a-74d1-95bf-5ae4ff305249",
    "storage_key": "property/6737460151192622/019e1e00-6c9a-74d1-95bf-5ae4ff305249.webp",
    "width": 750,
    "height": 300
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e8e87-4dba-7722-ae4e-1f6141fa42d1.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019e8e87-4dba-7722-ae4e-1f6141fa42d1",
    "storage_key": "property/6737460151192622/019e8e87-4dba-7722-ae4e-1f6141fa42d1.webp",
    "width": 750,
    "height": 300
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e8e87-3d98-73af-981e-b48cbee70d63.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e8e87-3d98-73af-981e-b48cbee70d63",
    "storage_key": "property/6737460151192622/019e8e87-3d98-73af-981e-b48cbee70d63.webp",
    "width": 750,
    "height": 300
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#15415d",
  "property_secondary_color": null,
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "413 - 1326",
  "property_sqft_min": "413",
  "property_sqft_max": "1326",
  "property_price_range": "856 - 1960",
  "property_price_min": "856",
  "property_price_max": "1960",
  "property_available_units": 41,
  "property_facebook_url": "https://www.facebook.com/BayVistaApt",
  "property_instagram_url": "https://www.instagram.com/bayvistaapartments/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJe3Q_s1deaIYRB_W-atmtn1M",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/bay-vista-pointe-corpus-christi",
  "property_tiktok_url": "https://www.tiktok.com/@bay.vista.apt.homes",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Bay Vista Apartments",
  "property_home_romance_title": "Embrace the Joy of Living in Your Ideal Apartment Community",
  "property_home_amenities_blurb": "<p>Experience the best of oceanfront living at Bay Vista in Corpus Christi, Texas! Discover affordable apartment living near the bay, with beautiful surroundings and an unbeatable location just steps from the beach. Enjoy the convenience of having everything you need close at hand, with many places within walking distance, including the downtown area and the sandy shores of the Gulf. Get exhilarated with trendy shops, fine dining, local hotspots, and fun entertainment. Plus, your commute will be easy and enjoyable with Interstate 37 and local highways nearby.</p>",
  "property_home_floorplans_blurb": "<p>Looking for a school, a place to go golfing, or your new workout facility? Check out this Neighborhood page for all of that and more! Plus, enjoy being just steps from the beach! Get to know your new Bay Vista Apartments community in Corpus Christi, TX!</p>",
  "property_home_gallery_blurb": "At Bay Vista Apartments in vibrant Corpus Christi, TX, your dream home awaits. Choose from stylish studio, one, or two-bedroom floor plans featuring modern amenities like a fitness center, pool, and sunroom. Picture yourself enjoying the scenic views and clubhouse—all within a gated community that feels like home.",
  "property_home_neighborhood_blurb": "Nestled in the heart of Corpus Christi, Bay Vista Apartments offers more than just stunning one-bedroom, two-bedroom, and studio floor plans. Immerse yourself in our vibrant neighborhood, where local gems and coastal charm await. Venture out to uncover your new favorite spots just steps from your door!",
  "property_home_reviews_blurb": "At Bay Vista Apartments in Corpus Christi, TX, our residents love the convenience and safety we provide. One resident shares, \"When I need my air filter changed, a simple email to the front office and it’s done!\" Join our dog-friendly community and experience the exceptional living we offer! See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "<p>Looking for a school, a place to go golfing, or your new workout facility? Check out this Neighborhood page for all of that and more! Plus, enjoy being just steps from the beach! Get to know your new Bay Vista Apartments community in Corpus Christi, TX!</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Your pets are welcome as family; they can experience a <a href=\"/gallery/\">new lifestyle</a> alongside you here at Bay Vista Apartments. Relax at the shimmering swimming pool or stay active in our state-of-the-art fitness center. Catch up with work using our business center, mingle in the resident clubhouse, or unwind outdoors in the picnic area. Our gated apartment community offers short-term leasing, corporate housing, and elevator access.</p>",
  "property_applynow_blurb": "At Bay Vista Apartments in Corpus Christi, TX, your ideal living space awaits. Choose from spacious studio, one-, or two-bedroom floor plans designed for comfort. Enjoy a pet-friendly atmosphere with a dog park, plus amenities like 24/7 maintenance and online services. Secure your new home and lease online today!",
  "property_contactus_blurb": "At Bay Vista Apartments in beautiful Corpus Christi, TX, our diverse floor plans—ranging from cozy studios to spacious two-bedrooms—ensure the perfect fit for your lifestyle. With breathtaking views and modern amenities, your new home awaits! Have questions? Contact our leasing team today for personalized assistance!",
  "property_faqs_blurb": "At Bay Vista Apartments in sunny Corpus Christi, TX, our diverse floor plans cater to every lifestyle, from cozy studios to spacious two-bedroom options. Got questions? Our FAQs page provides all the insights you need about our vibrant community. Dive in and find your perfect fit today!",
  "property_floorplans_blurb": "<p>Check out our wide range of spacious floor plans with studio, one and two bedroom apartments for rent. Try out delicious recipes on <a href=\"/gallery/\">your new black appliances</a> and keep everything ideally stored in gorgeous cherry cabinets. Walk-in closets provide extra space for your belongings, and select homes feature a balcony or patio and washer and dryer connections. Choose a bright sunroom for your indoor greenery or a Bay Vista apartment equipped with lovely views.</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/neighborhood/\">community</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "At Bay Vista Apartments in Corpus Christi, TX, you'll find spacious floor plans tailored to your lifestyle—choose from cozy studios, one, or two-bedroom options. Enjoy a vibrant community with pet-friendly amenities, 24/7 support, and an interactive map to help you find your perfect home today! Your new life awaits!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At Bay Vista Apartments in beautiful Corpus Christi, TX, living in harmony with great friends is just a referral away! Choose from spacious one-bedroom, two-bedroom, or cozy studio floor plans. Invite a friend to enjoy the vibrant community and stunning views—because great friends make great neighbors!",
  "property_residentaccess_blurb": "Welcome to Bay Vista Apartments in sunny Corpus Christi, TX! Whether you prefer a cozy studio, a spacious one-bedroom, or a roomier two-bedroom, we have the perfect layout for you. Access your resident portal to manage rent, schedule maintenance, and enjoy effortless community living. Your comfort awaits!",
  "property_reviews_blurb": "At Bay Vista Apartments in Corpus Christi, TX, residents rave about the convenience and safety of their gated community. One happy tenant shares, \"When I need my air filter changed, a simple email to the front office and it's done!\" Experience effortless living in a pet-friendly environment. See what our residents have to say!",
  "property_created_at": "1752257251718",
  "property_scheduletour_blurb": "At Bay Vista Apartments in sunny Corpus Christi, TX, choose from stylish studio, cozy one-bedroom, or spacious two-bedroom floor plans. Schedule a tour today to envision your next home and hear firsthand from our residents about their vibrant community experience. Your coastal oasis awaits! ",
  "property_thankyou_blurb": "Thank you for reaching out to Bay Vista Apartments in Corpus Christi, TX! With a variety of stylish floor plans—from cozy studios to spacious one and two-bedroom apartments—your ideal living space awaits. Our team will be in touch soon to help you find your perfect home by the bay.",
  "property_virtualtours_blurb": "<p>At Bay Vista, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of your new apartment home & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. Bay Vista Apartments",
  "property_seo_title_home": "Bay Vista Apartments | Apartments in Corpus Christi, TX",
  "property_seo_description_home": "Welcome to Bay Vista Apartments in sunny Corpus Christi, TX—where modern living meets tranquility. Choose from versatile floor plans, including stylish studios, spacious one and two-bedroom options, perfectly designed for your lifestyle. Enjoy pet-friendly amenities like our dog park and pet park, along with 24/7 on-site support, online services, and a resident referral program. With our commitment to sustainability, we make recycling easy! Experience the ultimate in comfort, convenience, and community. Your new home is waiting—start your journey today!",
  "property_seo_title_floorplans": "Floor Plans | studio - 2 Apartments in Corpus Christi, TX",
  "property_seo_description_floorplans": "Unveil your dream living space at Bay Vista Apartments in sunny Corpus Christi, TX. Our versatile floor plans cater to every lifestyle, whether you’re seeking a cozy studio, a spacious one-bedroom, or a luxurious two-bedroom retreat. Dive into our selection of thoughtfully designed layouts and embrace a life of comfort. Browse our available apartment homes today to find the perfect floor plan that suits your needs!",
  "property_seo_title_amenities": "Amenities | Corpus Christi, TX Apartments for Rent",
  "property_seo_description_amenities": "Experience comfortable living at Bay Vista Apartments in Corpus Christi, TX, where your lifestyle meets convenience. Choose from spacious one-bedroom, two-bedroom, and studio floor plans tailored to your needs. Enjoy a pet-friendly environment with a dog park and pet park, complemented by 24-hour on-call maintenance services. Benefit from online resident services, a resident referral program, and secure package receiving for hassle-free living. With amenities like a TV lounge, garage access, and an accessible elevator, every detail is crafted for your comfort. Dive into a community that values recycling, safety, and storage solutions. Your ideal home awaits—uncover all that Bay Vista has to offer!",
  "property_seo_title_gallery": "Gallery | Apartments in Corpus Christi, TX",
  "property_seo_description_gallery": "\"Unwind at Bay Vista Apartments in Corpus Christi, TX, where spacious floor plans and pet-friendly amenities create an inviting home environment. From our on-site dog park to the 24/7 resident services, every detail is designed for comfort and convenience. Experience a lifestyle that offers more than just a place to live—check out our photo gallery and picture yourself in this vibrant community!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Bay Vista Apartments Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Bay Vista Apartments in Corpus Christi, TX, where style meets comfort. Whether you’re searching for a cozy studio or a spacious two-bedroom, our diverse floor plans cater to your unique lifestyle. Ready to see it all? Experience our vibrant community and available apartments through an immersive virtual tour!",
  "property_seo_title_interactivemap": "Interactive Map | Bay Vista Apartments Apartments",
  "property_seo_description_interactivemap": "\"Welcome to Bay Vista Apartments in beautiful Corpus Christi, TX, where spacious living meets top-notch amenities tailored just for you! Whether you're looking for a cozy studio or a spacious two-bedroom, our unique floor plans are designed for comfort. Enjoy our pet-friendly community featuring a dog park, a recycling initiative, and a 24/7 online resident service to cater to your needs. Navigate our interactive community map to find your perfect home today and take advantage of our resident referral program and convenient package receiving options!\"",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Corpus Christi, TX",
  "property_seo_description_neighborhood": "Experience coastal living at Bay Vista Apartments in Corpus Christi, TX. Nestled in a vibrant neighborhood, our community offers convenient access to local favorites, picturesque parks, and charming eateries. Uncover the best-kept secrets and popular hotspots just beyond your doorstep. See what's around our community and embrace the lively spirit of Corpus Christi today!",
  "property_seo_title_contact": "Contact Us | Bay Vista Apartments",
  "property_seo_description_contact": "Experience the charm of Bay Vista Apartments in Corpus Christi, TX, where diverse living options—including stylish one-bedroom, spacious two-bedroom, and cozy studio units—await you. Have questions? Our leasing team is ready to assist you today!",
  "property_seo_title_faqs": "FAQs | Apartments in Corpus Christi, TX",
  "property_seo_description_faqs": "Unlock the secrets of Bay Vista Apartments, where comfort meets convenience in the heart of Corpus Christi, TX. With spacious one and two-bedroom floor plans and cozy studios, our community is designed for modern living. Enjoy a pet-friendly atmosphere complemented by an inviting dog park, excellent amenities like a 24-hour on-call maintenance team, online payment options, and more. Curious about what we offer? Navigate our FAQs page for insights into our unique features and how we elevate your living experience.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Corpus Christi, TX",
  "property_seo_description_reviews": "\"Join the Bay Vista Apartments community in sunny Corpus Christi, TX, and see why our residents love calling us home! From spacious one and two-bedroom floor plans to pet-friendly amenities like our vibrant dog park, we cater to your lifestyle. Enjoy round-the-clock support, convenient online services, and a welcoming atmosphere where comfort meets convenience. Curious about life here? Discover the stories and experiences of our residents that make Bay Vista your ideal sanctuary.\"",
  "property_seo_title_applynow": "Apply Now | Apartments in Corpus Christi, TX",
  "property_seo_description_applynow": "Experience modern living at Bay Vista Apartments in Corpus Christi, TX, where spacious floor plans meet exceptional amenities. Choose from stylish studios, one, and two-bedroom apartments designed for comfort and convenience. Embrace a pet-friendly environment with a dedicated dog park, indulge in our TV lounge, and enjoy 24/7 maintenance and online services. With our resident referral program and commitment to sustainability, you'll feel right at home. Make the smart move—apply now and secure your new oasis!",
  "property_seo_title_residentaccess": "Resident Access | Bay Vista Apartments",
  "property_seo_description_residentaccess": "Unlock the convenience of Bay Vista Apartments in Corpus Christi, TX! Log in to your resident portal for easy rent payments, hassle-free maintenance requests, and exclusive community updates. Your comfortable living experience starts here!",
  "property_seo_title_referafriend": "Refer A Friend | Bay Vista Apartments",
  "property_seo_description_referafriend": "Refer a friend to Bay Vista Apartments and turn your community into a vibrant social hub! With stunning views and a lifestyle designed for connection, your recommendation not only enriches your circle but also welcomes new neighbors to a home they’ll love!",
  "property_seo_title_scheduletour": "Schedule a Tour | Bay Vista Apartments",
  "property_seo_description_scheduletour": "\"Step into your future at Bay Vista Apartments in Corpus Christi, TX, where coastal charm meets modern living. Embrace vibrant community life surrounded by stunning bay views. Ready to make it yours? Schedule a tour today and experience the lifestyle you’ve been dreaming of!\"",
  "property_seo_title_privacy": "Privacy Policy | Bay Vista Apartments",
  "property_seo_description_privacy": "Your privacy matters at Bay Vista Apartments in beautiful Corpus Christi, TX. Dive into our transparency and commitment to safeguarding your information. Curious about how we protect your data? Read our detailed privacy policy for peace of mind in your coastal home.",
  "property_seo_title_accessibility": "Website Accessibility | Bay Vista Apartments",
  "property_seo_description_accessibility": "\"At Bay Vista Apartments in Corpus Christi, TX, we prioritize accessibility for all residents and visitors. Our commitment to digital inclusion ensures that everyone can easily navigate our services and community features. Join us in creating an accessible living experience that embraces diversity and fosters connection.\"",
  "property_seo_title_sitemap": "Sitemap | Bay Vista Apartments",
  "property_seo_description_sitemap": "Navigate your way to your future home at Bay Vista Apartments in Corpus Christi, TX. Our sitemap provides a bird's-eye view of our stunning community, amenities, and available floor plans. Uncover all that awaits you and start planning your perfect living experience today!",
  "property_seo_title_thankyou": "Thank You | Bay Vista Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out to Bay Vista Apartments in beautiful Corpus Christi, TX! Your interest means the world to us. A dedicated team member will be in touch soon to help you find your perfect home by the bay. Stay tuned for a brighter, more vibrant living experience!",
  "property_seo_title_pets": "Pet Policy | Apartments in Corpus Christi, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293640953",
  "amenities": [
    {
      "id": "ec_3555071151a2147e2dfb0abc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f1ff56107ec281083fde5254",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "external_id": "false",
      "title": "Cable Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ff5f4cad4b07ffb525204b62",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "external_id": "false",
      "title": "Corporate Housing",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fcfa2253a96e3ce6a5762afd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "external_id": "false",
      "title": "Covered and Assigned Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_67806fc14f1dc7225eb8a40f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "external_id": "false",
      "title": "Easy Access to Shopping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_685d14f2fb678a82cf8b249d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "external_id": "false",
      "title": "Elevator Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cd782a81873b5996bbf52d52",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "external_id": "false",
      "title": "Gated Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_16c32330cba8a3d438746bea",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "external_id": "false",
      "title": "High‑speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1c151757128dc0bee6710187",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "external_id": "false",
      "title": "On‑call and On‑site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6b514a080fff53ac04f3a41c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "external_id": "false",
      "title": "Picnic Area with Barbecue",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cc6fdacd20343c44e6eceeee",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "external_id": "false",
      "title": "Public Parks Nearby",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_22053673f9a4f49ae49d129b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "external_id": "false",
      "title": "Resident Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7205b95d6fdaf6497299cfeb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "external_id": "false",
      "title": "Resident Events",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0aade660de8659b57f025b0c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "external_id": "false",
      "title": "Shimmering Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_028d837c4b052bea7726a30d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "external_id": "false",
      "title": "Short‑term Leasing Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4e1d5c56fbf7e098e4b2a920",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "external_id": "false",
      "title": "State‑of‑the‑art Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0eee91b1d80bb80e6d260861",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "external_id": "false",
      "title": "Balcony or Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_53aadf7b136f70cfd677d2b5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "external_id": "false",
      "title": "Black Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9774ee8e913a71f06d4967bb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_26d88edaf5c77a9e5b9fc646",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "external_id": "false",
      "title": "Cherry Cabinets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_27faeb7ce66969e4432a49e0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_167568d623647d498abbeb37",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "external_id": "false",
      "title": "Sunroom",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4be6f1caf4b0b7404017c598",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "external_id": "false",
      "title": "Views Available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a2d31f52d2d6861510cae9dd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "external_id": "false",
      "title": "Walk‑in Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_42657df9d482e528d8be07be",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "external_id": "false",
      "title": "Washer and Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_0dba22de-0b69-4d55-bcb5-10aba44065bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d4-8e10-70f8-9900-c8fd67b1ecb0.webp",
      "image_media": {
        "alt_text": "Well-equipped fitness center with treadmills, weight machines, and mirrored walls.",
        "public_id": "019e60d4-8e10-70f8-9900-c8fd67b1ecb0",
        "storage_key": "property/6737460151192622/019e60d4-8e10-70f8-9900-c8fd67b1ecb0.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring a variety of cardio and strength training machines to help you reach your wellness goals.",
      "link": "",
      "alt_text": "Well-equipped fitness center with treadmills, weight machines, and mirrored walls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_89fe601a-a172-4df8-be04-8b5cf7f33bfc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d4-8ca8-769f-9fc8-9b7c4ac95c71.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, black appliances, and marble countertops.",
        "public_id": "019e60d4-8ca8-769f-9fc8-9b7c4ac95c71",
        "storage_key": "property/6737460151192622/019e60d4-8ca8-769f-9fc8-9b7c4ac95c71.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring dark wood cabinetry, sleek black appliances including a refrigerator, oven, and microwave, complemented by elegant marble countertops.",
      "link": "",
      "alt_text": "Kitchen with dark wood cabinets, black appliances, and marble countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_58091598-f8ce-4749-973d-b3e5e6485e3e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d4-8cbe-7552-96f8-930e274029f1.webp",
      "image_media": {
        "alt_text": "Living room with a yellow sofa, coffee table, and dining area.",
        "public_id": "019e60d4-8cbe-7552-96f8-930e274029f1",
        "storage_key": "property/6737460151192622/019e60d4-8cbe-7552-96f8-930e274029f1.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable yellow sofa, decorative coffee table, and a bright dining nook, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with a yellow sofa, coffee table, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_43e60fe4-cded-40bf-acae-1eaeabd60657",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d4-8acf-761f-916f-c34385c24f5d.webp",
      "image_media": {
        "alt_text": "Living room with a TV, coffee table, and a glimpse of a bedroom.",
        "public_id": "019e60d4-8acf-761f-916f-c34385c24f5d",
        "storage_key": "property/6737460151192622/019e60d4-8acf-761f-916f-c34385c24f5d.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Stylish living area featuring a wall-mounted TV, a coffee table, and a view into a well-appointed bedroom.",
      "link": "",
      "alt_text": "Living room with a TV, coffee table, and a glimpse of a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_302b9a52-dff2-4194-84d2-b836ff774dda",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d4-885f-70e0-a3ed-68dccd93cdaa.webp",
      "image_media": {
        "alt_text": "Stylish living room with yellow couch, coffee table, and TV.",
        "public_id": "019e60d4-885f-70e0-a3ed-68dccd93cdaa",
        "storage_key": "property/6737460151192622/019e60d4-885f-70e0-a3ed-68dccd93cdaa.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Beautifully appointed living room featuring a comfortable yellow sofa, a modern coffee table, and a wall-mounted television, perfect for relaxation.",
      "link": "",
      "alt_text": "Stylish living room with yellow couch, coffee table, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0115188b-4116-43bb-bff4-ed04f43a4e55",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d4-84c3-711a-9406-f52e7fa02a29.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, decorative pillows, and bedside tables.",
        "public_id": "019e60d4-84c3-711a-9406-f52e7fa02a29",
        "storage_key": "property/6737460151192622/019e60d4-84c3-711a-9406-f52e7fa02a29.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Relax in comfort in this charming bedroom, featuring a plush queen-size bed and elegant bedside furnishings.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, decorative pillows, and bedside tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6f60569b-2d17-4408-93b3-3687ea70f250",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d4-7bf4-738c-98c0-0ea4d802b344.webp",
      "image_media": {
        "alt_text": "Bathroom with a bathtub and shower curtain, and a glimpse of a bedroom and kitchen.",
        "public_id": "019e60d4-7bf4-738c-98c0-0ea4d802b344",
        "storage_key": "property/6737460151192622/019e60d4-7bf4-738c-98c0-0ea4d802b344.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "View of a clean and functional bathroom featuring a bathtub with a shower curtain, adjacent to a bedroom and a modern kitchen area.",
      "link": "",
      "alt_text": "Bathroom with a bathtub and shower curtain, and a glimpse of a bedroom and kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0dcdbd3f-d52a-47c6-baa3-243a4b86f881",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d4-7d73-758a-9bc5-b5a1d6dc157c.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area in an apartment.",
        "public_id": "019e60d4-7d73-758a-9bc5-b5a1d6dc157c",
        "storage_key": "property/6737460151192622/019e60d4-7d73-758a-9bc5-b5a1d6dc157c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish living room with a sofa, armchair, and coffee table, opening to a modern kitchen with dark wood cabinets and black appliances.",
      "link": "",
      "alt_text": "Living room and kitchen area in an apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d8500496-c9ed-4fe7-aa94-4c085fd6e4b1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d4-7a53-71db-9f09-6945839e0fb4.webp",
      "image_media": {
        "alt_text": "Aerial view of a large apartment complex with multiple buildings, overlooking the ocean.",
        "public_id": "019e60d4-7a53-71db-9f09-6945839e0fb4",
        "storage_key": "property/6737460151192622/019e60d4-7a53-71db-9f09-6945839e0fb4.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Experience coastal living at this expansive apartment community, featuring multiple buildings with scenic ocean views.",
      "link": "",
      "alt_text": "Aerial view of a large apartment complex with multiple buildings, overlooking the ocean.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_faca4d25-db96-4df5-80ef-0b3db80cc28b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d4-7839-706f-844d-124c8f5f21e6.webp",
      "image_media": {
        "alt_text": "Aerial view of a multi-building apartment complex with a water view and parking garage.",
        "public_id": "019e60d4-7839-706f-844d-124c8f5f21e6",
        "storage_key": "property/6737460151192622/019e60d4-7839-706f-844d-124c8f5f21e6.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Experience coastal living at this apartment community, featuring scenic water views and convenient parking options.",
      "link": "",
      "alt_text": "Aerial view of a multi-building apartment complex with a water view and parking garage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2246cde1-ac0d-408a-8263-64c470645eaf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d4-532f-73ce-8888-ed28ffa603d9.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex courtyard with swimming pool and surrounding buildings.",
        "public_id": "019e60d4-532f-73ce-8888-ed28ffa603d9",
        "storage_key": "property/6737460151192622/019e60d4-532f-73ce-8888-ed28ffa603d9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our beautiful outdoor swimming pool, the perfect place to relax and unwind after a long day.",
      "link": "",
      "alt_text": "Aerial view of apartment complex courtyard with swimming pool and surrounding buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bf059b47-7d21-4df6-aa5c-3680b5875d90",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d4-405d-7137-92be-0ecc55a3e898.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with a rock waterfall feature and lounge chairs, adjacent to a modern apartment building.",
        "public_id": "019e60d4-405d-7137-92be-0ecc55a3e898",
        "storage_key": "property/6737460151192622/019e60d4-405d-7137-92be-0ecc55a3e898.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning resort-style swimming pool. Perfect for sunny days and making memories.",
      "link": "",
      "alt_text": "Resort-style swimming pool with a rock waterfall feature and lounge chairs, adjacent to a modern apartment building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_09511dc5-1f87-46f2-8bcd-1b35d02b9cd1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d4-2ef6-752a-920f-c5cbe8a72e0c.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstands, and a closet.",
        "public_id": "019e60d4-2ef6-752a-920f-c5cbe8a72e0c",
        "storage_key": "property/6737460151192622/019e60d4-2ef6-752a-920f-c5cbe8a72e0c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a queen-size bed, decorative bedding, and ample closet space.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstands, and a closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3331c0bd-9915-4c28-a2da-ab1c9feb09a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d4-3973-75ce-a225-e1f2c3c42e68.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with a rock waterfall and lounge chairs in front of a tan apartment building.",
        "public_id": "019e60d4-3973-75ce-a225-e1f2c3c42e68",
        "storage_key": "property/6737460151192622/019e60d4-3973-75ce-a225-e1f2c3c42e68.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, featuring a unique rock waterfall and ample lounge seating, perfect for soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with a rock waterfall and lounge chairs in front of a tan apartment building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_577d7b49-4bff-48d2-adf9-6e82d06c30aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d4-2ed2-74ac-95e0-eeb08a1a09cd.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, dresser, and closet.",
        "public_id": "019e60d4-2ed2-74ac-95e0-eeb08a1a09cd",
        "storage_key": "property/6737460151192622/019e60d4-2ed2-74ac-95e0-eeb08a1a09cd.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, ample dresser storage, and a walk-in closet, perfect for unwinding.",
      "link": "",
      "alt_text": "Bedroom with a large bed, dresser, and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_259e47bf-a1c2-46ae-ad8e-4706c3208365",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d4-3916-7261-8c1d-696b2042582a.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with sofa, chairs, coffee table, and kitchen appliances.",
        "public_id": "019e60d4-3916-7261-8c1d-696b2042582a",
        "storage_key": "property/6737460151192622/019e60d4-3916-7261-8c1d-696b2042582a.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Spacious living area seamlessly connected to a modern kitchen, perfect for entertaining.",
      "link": "",
      "alt_text": "Living room and kitchen area with sofa, chairs, coffee table, and kitchen appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_be063847-eedc-4b3d-ae8d-ce2060321b44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d4-2dd9-756b-a49a-a6d189569223.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a king-size bed, plush carpet, and beach-themed artwork.",
        "public_id": "019e60d4-2dd9-756b-a49a-a6d189569223",
        "storage_key": "property/6737460151192622/019e60d4-2dd9-756b-a49a-a6d189569223.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Experience comfort in this inviting bedroom, featuring a king-size bed adorned with soft linens, complemented by neutral tones and beach-inspired wall art for a tranquil atmosphere.",
      "link": "",
      "alt_text": "Cozy bedroom with a king-size bed, plush carpet, and beach-themed artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4cfdc39b-85c6-466d-b87e-32809b991034",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d4-2d75-7599-b826-17440d0675f0.webp",
      "image_media": {
        "alt_text": "Bathroom with double vanity, toilet, and shower",
        "public_id": "019e60d4-2d75-7599-b826-17440d0675f0",
        "storage_key": "property/6737460151192622/019e60d4-2d75-7599-b826-17440d0675f0.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with ample counter space, a private toilet area, and a separate glass-enclosed shower.",
      "link": "",
      "alt_text": "Bathroom with double vanity, toilet, and shower",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dc0f004a-ff39-46a6-9276-d749821b06e1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d4-24a5-71e8-97e9-af194c0a2577.webp",
      "image_media": {
        "alt_text": "Bedroom with a dresser, mirror, and open closet",
        "public_id": "019e60d4-24a5-71e8-97e9-af194c0a2577",
        "storage_key": "property/6737460151192622/019e60d4-24a5-71e8-97e9-af194c0a2577.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a white dresser with a decorative mirror above, a king-size bed with a textured comforter, and a walk-in closet.",
      "link": "",
      "alt_text": "Bedroom with a dresser, mirror, and open closet",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1ec8942b-de4f-4e92-a776-7316d2b9f90f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d4-1899-761b-ba13-fd16b178b083.webp",
      "image_media": {
        "alt_text": "Community lounge area with comfortable seating, a TV, and decorative art.",
        "public_id": "019e60d4-1899-761b-ba13-fd16b178b083",
        "storage_key": "property/6737460151192622/019e60d4-1899-761b-ba13-fd16b178b083.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, featuring plush seating, entertainment options, and stylish decor for residents to enjoy.",
      "link": "",
      "alt_text": "Community lounge area with comfortable seating, a TV, and decorative art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ae8f4eef-61de-4422-bebf-7d5aa3efc51c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d4-1164-748e-80b8-17cdfab70d6e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with wooden cabinets, black appliances, and stainless steel sink.",
        "public_id": "019e60d4-1164-748e-80b8-17cdfab70d6e",
        "storage_key": "property/6737460151192622/019e60d4-1164-748e-80b8-17cdfab70d6e.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Experience the convenience of this well-equipped kitchen, featuring ample cabinet space, a full suite of black appliances including a microwave and refrigerator, and a stylish stainless steel sink.",
      "link": "",
      "alt_text": "Modern kitchen with wooden cabinets, black appliances, and stainless steel sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1cffd52c-1bd1-4597-b1c3-3ab00e590005",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d4-0da6-710f-8759-dc3948a1326b.webp",
      "image_media": {
        "alt_text": "A stylish living room featuring a yellow sofa with decorative pillows, a coffee table, and a small dining area.",
        "public_id": "019e60d4-0da6-710f-8759-dc3948a1326b",
        "storage_key": "property/6737460151192622/019e60d4-0da6-710f-8759-dc3948a1326b.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed living room, complete with a comfortable yellow sofa, accent chair, and a cozy dining nook perfect for intimate meals.",
      "link": "",
      "alt_text": "A stylish living room featuring a yellow sofa with decorative pillows, a coffee table, and a small dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f4cb100e-f381-4768-85ff-787334d7b904",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d4-09da-70aa-bdb8-903588e180aa.webp",
      "image_media": {
        "alt_text": "Living room with a yellow sofa, patterned armchair, and kitchen in the background.",
        "public_id": "019e60d4-09da-70aa-bdb8-903588e180aa",
        "storage_key": "property/6737460151192622/019e60d4-09da-70aa-bdb8-903588e180aa.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed living room, featuring a plush yellow sofa and a stylish armchair. The open-concept design seamlessly connects to a modern kitchen, perfect for entertaining.",
      "link": "",
      "alt_text": "Living room with a yellow sofa, patterned armchair, and kitchen in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1305dd0b-b118-47e1-a131-310ce899d0c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d4-09e4-74d9-9066-8066df8da8b6.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, weight machines, and mirrors.",
        "public_id": "019e60d4-09e4-74d9-9066-8066df8da8b6",
        "storage_key": "property/6737460151192622/019e60d4-09e4-74d9-9066-8066df8da8b6.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with cardio and strength training equipment for residents.",
      "link": "",
      "alt_text": "Fitness center with treadmills, weight machines, and mirrors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d8ed5451-c07a-4fa3-9a99-e97f129408cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d4-0632-71b8-8636-fe416d513632.webp",
      "image_media": {
        "alt_text": "Living room with a TV, console table, coffee table, dining area, and entrance to bedroom.",
        "public_id": "019e60d4-0632-71b8-8636-fe416d513632",
        "storage_key": "property/6737460151192622/019e60d4-0632-71b8-8636-fe416d513632.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a wall-mounted TV, a stylish console table, a coffee table, and a dining nook. An opening reveals a glimpse of the bedroom.",
      "link": "",
      "alt_text": "Living room with a TV, console table, coffee table, dining area, and entrance to bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_284e38f9-11f1-4c92-a9d2-eb1bbbc88cac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d3-fd97-713a-a807-fda2d7f14158.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with a parking garage and the ocean in the background.",
        "public_id": "019e60d3-fd97-713a-a807-fda2d7f14158",
        "storage_key": "property/6737460151192622/019e60d3-fd97-713a-a807-fda2d7f14158.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Beautiful apartment buildings with a view of the ocean and a convenient parking garage.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with a parking garage and the ocean in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2518b773-4652-44fc-82e1-2ac20c27c158",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d4-0049-76cf-8a19-3862de3de35c.webp",
      "image_media": {
        "alt_text": "Aerial view of a large apartment complex with multiple buildings and a view of the ocean in the background.",
        "public_id": "019e60d4-0049-76cf-8a19-3862de3de35c",
        "storage_key": "property/6737460151192622/019e60d4-0049-76cf-8a19-3862de3de35c.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Experience coastal living at this apartment complex, featuring multiple buildings with spacious layouts and stunning ocean views. Enjoy the convenience of a prime location near the waterfront.",
      "link": "",
      "alt_text": "Aerial view of a large apartment complex with multiple buildings and a view of the ocean in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_141abd0f-2ca1-4371-a9db-46e0e8230d1f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d4-01d0-7716-ba86-7c5c114f679b.webp",
      "image_media": {
        "alt_text": "Living room with sofa, coffee table, TV, and kitchen visible.",
        "public_id": "019e60d4-01d0-7716-ba86-7c5c114f679b",
        "storage_key": "property/6737460151192622/019e60d4-01d0-7716-ba86-7c5c114f679b.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable sofa, modern coffee table, and wall-mounted TV, open to a well-equipped kitchen.",
      "link": "",
      "alt_text": "Living room with sofa, coffee table, TV, and kitchen visible.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_341f00f0-8025-4eda-8fc7-b5fc78d5013e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d3-fd0a-76bf-ba0d-e6d71d34e9b7.webp",
      "image_media": {
        "alt_text": "View of an apartment bathroom with a bathtub and shower curtain, opening to a bedroom and kitchen area.",
        "public_id": "019e60d3-fd0a-76bf-ba0d-e6d71d34e9b7",
        "storage_key": "property/6737460151192622/019e60d3-fd0a-76bf-ba0d-e6d71d34e9b7.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Step into a bright and spacious apartment featuring a clean bathroom with a bathtub and shower, a comfortable bedroom, and a modern kitchen.",
      "link": "",
      "alt_text": "View of an apartment bathroom with a bathtub and shower curtain, opening to a bedroom and kitchen area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_93ae63c7-74fd-4bcc-8901-6d97a450791f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d3-fe5c-7658-84ca-7c1eb8dc293b.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstands, and a ceiling fan.",
        "public_id": "019e60d3-fe5c-7658-84ca-7c1eb8dc293b",
        "storage_key": "property/6737460151192622/019e60d3-fe5c-7658-84ca-7c1eb8dc293b.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a queen-size bed with decorative pillows, bedside tables with lamps, and a ceiling fan for comfort. This inviting space offers a tranquil retreat.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstands, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4b60f1c3-8df6-4c67-863b-372fc9f4d56f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d3-eb8d-77d3-ab12-2851f95d3efa.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019e60d3-eb8d-77d3-ab12-2851f95d3efa",
        "storage_key": "property/6737460151192622/019e60d3-eb8d-77d3-ab12-2851f95d3efa.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, surrounded by lush landscaping and modern apartment buildings. Enjoy a refreshing dip or lounge in the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_029cbf0e-4121-484f-a8f7-04689246ab63",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d3-ecd2-75d8-b785-8f3d862676eb.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with a waterfall feature and lounge chairs at a multifamily property.",
        "public_id": "019e60d3-ecd2-75d8-b785-8f3d862676eb",
        "storage_key": "property/6737460151192622/019e60d3-ecd2-75d8-b785-8f3d862676eb.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, featuring a soothing waterfall and ample lounge seating for ultimate relaxation. Perfect for sunny days and unwinding after a long day.",
      "link": "",
      "alt_text": "Resort-style swimming pool with a waterfall feature and lounge chairs at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2f7740fa-9c58-4fa1-bb9f-0de379b0a758",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d3-eb8a-740d-8578-b84ea33426b6.webp",
      "image_media": {
        "alt_text": "Living room with gray sofa, two leather armchairs, coffee table, and kitchen area.",
        "public_id": "019e60d3-eb8a-740d-8578-b84ea33426b6",
        "storage_key": "property/6737460151192622/019e60d3-eb8a-740d-8578-b84ea33426b6.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Stylish living room with comfortable seating and a modern kitchen, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with gray sofa, two leather armchairs, coffee table, and kitchen area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4e5be907-467e-4ab1-a8bf-85d32891d985",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d3-e7c2-74a7-9629-831ea572c520.webp",
      "image_media": {
        "alt_text": "Queen size bed with coastal-themed bedding in a bedroom with a large closet and palm plant.",
        "public_id": "019e60d3-e7c2-74a7-9629-831ea572c520",
        "storage_key": "property/6737460151192622/019e60d3-e7c2-74a7-9629-831ea572c520.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a queen bed with beautiful coastal-themed bedding. Includes a spacious closet and elegant bedside lamps.",
      "link": "",
      "alt_text": "Queen size bed with coastal-themed bedding in a bedroom with a large closet and palm plant.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_889a2ac7-6f1c-4f81-aee2-900fe14093b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d3-e7c1-7587-bf8b-aff785cd0ad7.webp",
      "image_media": {
        "alt_text": "Resort-style pool with rock waterfall and lounge chairs.",
        "public_id": "019e60d3-e7c1-7587-bf8b-aff785cd0ad7",
        "storage_key": "property/6737460151192622/019e60d3-e7c1-7587-bf8b-aff785cd0ad7.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by our sparkling resort-style pool, complete with a cascading rock waterfall and ample lounge seating for your comfort.",
      "link": "",
      "alt_text": "Resort-style pool with rock waterfall and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_37a02c5a-6ff1-4076-b3a1-d27378cefd7d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d3-e778-721c-9cde-fc3def3f9d80.webp",
      "image_media": {
        "alt_text": "Bedroom with a dresser, mirror, and closet",
        "public_id": "019e60d3-e778-721c-9cde-fc3def3f9d80",
        "storage_key": "property/6737460151192622/019e60d3-e778-721c-9cde-fc3def3f9d80.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Bright and airy bedroom featuring a white dresser, decorative mirror, and a spacious closet. Adjacent bathroom visible through the doorway.",
      "link": "",
      "alt_text": "Bedroom with a dresser, mirror, and closet",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e0d38125-6d19-44ec-8646-6e4eda86364e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d3-e7ab-765b-9efe-ef75fed6aebd.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, large mirror, and glass-enclosed shower.",
        "public_id": "019e60d3-e7ab-765b-9efe-ef75fed6aebd",
        "storage_key": "property/6737460151192622/019e60d3-e7ab-765b-9efe-ef75fed6aebd.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Step into this stylish bathroom featuring a double vanity with ample counter space, a large mirror, and a spacious glass-enclosed shower. Perfect for a relaxing start or end to your day.",
      "link": "",
      "alt_text": "Modern bathroom with double vanity, large mirror, and glass-enclosed shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c3ab44c7-1354-4f01-a5a4-fd52e7048c2f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d3-e94f-7349-81aa-ab50f9f4cc48.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, dresser, closet, and en-suite bathroom.",
        "public_id": "019e60d3-e94f-7349-81aa-ab50f9f4cc48",
        "storage_key": "property/6737460151192622/019e60d3-e94f-7349-81aa-ab50f9f4cc48.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a queen-size bed with coastal-themed bedding, a white dresser with lamps, and a spacious walk-in closet. Access to the en-suite bathroom is also visible.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, dresser, closet, and en-suite bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c0213cb0-84c2-4406-9e24-52f92df2af02",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d3-e710-756b-a0b4-ecac81fadc38.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, nightstand, dresser, and a ceiling fan.",
        "public_id": "019e60d3-e710-756b-a0b4-ecac81fadc38",
        "storage_key": "property/6737460151192622/019e60d3-e710-756b-a0b4-ecac81fadc38.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Relax in comfort in this spacious bedroom, featuring a plush queen-size bed, ample storage with a dresser and nightstand, and a cooling ceiling fan.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, nightstand, dresser, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_756be144-c2dc-4d63-9e8e-f883506f7789",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e60d3-e6e3-73d1-b34f-dda4319a1b9e.webp",
      "image_media": {
        "alt_text": "Comfortable lounge area with seating, a TV, and decorative art.",
        "public_id": "019e60d3-e6e3-73d1-b34f-dda4319a1b9e",
        "storage_key": "property/6737460151192622/019e60d3-e6e3-73d1-b34f-dda4319a1b9e.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring plush seating, a large TV, and chic artwork.",
      "link": "",
      "alt_text": "Comfortable lounge area with seating, a TV, and decorative art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_8dc7b569-66fb-48f3-8c03-efc70944efc4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "Whataburger",
      "poi_type": "Restaurants",
      "poi_address": "121 N Shoreline Blvd, Corpus Christi, TX 78401, USA",
      "poi_short_description": "Fast-food chain serving its signature big burgers and other comfort fare in a family-run spot.",
      "poi_long_description": "People say this fast food restaurant serves great burgers, including the classic Whataburger, Avocado Bacon Burger, and Justaburger kids' meal. They also highlight the good value, the unique two-story building with an ocean view, and the friendly and efficient service.\n\nSome reviews mention the orders can be inaccurate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-9d50-7652-a16c-99d054ad9b4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-9d50-7652-a16c-99d054ad9b4d",
        "storage_key": "property/6737460151192622/019d0783-9d50-7652-a16c-99d054ad9b4d.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://locations.whataburger.com/tx/corpus-christi/121-n-shoreline-blvd.html/?utm_source=yextpages&utm_medium=locallistings&utm_campaign=yextpages",
      "poi_directions_map_url": "https://maps.google.com/?cid=3140747452028099235&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "whataburger",
      "poi_latitude": "27.7924445",
      "poi_longitude": "-97.3929834",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 361-881-9925",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-d9cc-7110-b726-6a8e95ae6770.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-d9cc-7110-b726-6a8e95ae6770",
        "storage_key": "property/6737460151192622/019d0783-d9cc-7110-b726-6a8e95ae6770.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXyZsxfVeaIYRoxpZzyotlis",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_f34961bd-6b95-4fa1-883c-60ab4d65f67e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "5425 S Padre Island Dr #138, Corpus Christi, TX 78411, USA",
      "poi_short_description": "Family focused casual chain diner offering their specialty chicken fingers & a range of sides.",
      "poi_long_description": "Family focused casual chain diner offering their specialty chicken fingers & a range of sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-9e00-7255-8772-43ed653c491f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-9e00-7255-8772-43ed653c491f",
        "storage_key": "property/6737460151192622/019d0783-9e00-7255-8772-43ed653c491f.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/tx/corpus-christi/5425-s.-padre-island-dr.-lot-138",
      "poi_directions_map_url": "https://maps.google.com/?cid=13479109790356687838&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "27.707459",
      "poi_longitude": "-97.3711815",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 361-906-0838",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-d9cc-7110-b726-6a8e95ae6770.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-d9cc-7110-b726-6a8e95ae6770",
        "storage_key": "property/6737460151192622/019d0783-d9cc-7110-b726-6a8e95ae6770.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzbz--Mz1aIYR3kuzXvBqD7s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_fbdb5b2a-8d97-4f0a-900e-d85aadba85d4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "Water Street Oyster Bar",
      "poi_type": "Restaurants",
      "poi_address": "309 N Water St, Corpus Christi, TX 78401, USA",
      "poi_short_description": "Half-price oysters and sushi draw happy-hour crowds to this casual eatery.",
      "poi_long_description": "People say this restaurant serves fresh oysters, calamari, and wood-grilled oysters. They also highlight the friendly and attentive staff, and the spacious, modern atmosphere.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-9d42-709a-9b66-1a891c3f5de8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-9d42-709a-9b66-1a891c3f5de8",
        "storage_key": "property/6737460151192622/019d0783-9d42-709a-9b66-1a891c3f5de8.webp",
        "width": 1280,
        "height": 590
      },
      "poi_business_url": "http://www.waterstmarketcc.com/oyster-bar-cc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9551708255403572161&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "water-street-oyster-bar",
      "poi_latitude": "27.7943618",
      "poi_longitude": "-97.393527",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 361-881-9448",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-d9cc-7110-b726-6a8e95ae6770.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-d9cc-7110-b726-6a8e95ae6770",
        "storage_key": "property/6737460151192622/019d0783-d9cc-7110-b726-6a8e95ae6770.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPZ9boPVeaIYRwft-GQ18joQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_8f26b34b-9e46-4cd2-9528-7079e0061431",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "2029 S Padre Island Dr, Corpus Christi, TX 78416, USA",
      "poi_short_description": "Steaks, ribs, and other American comfort food served in a cozy, casual space.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and rolls with honey cinnamon butter. They also highlight the quick service, friendly staff, and fun atmosphere.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-9d55-7608-9a21-06f15887001a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-9d55-7608-9a21-06f15887001a",
        "storage_key": "property/6737460151192622/019d0783-9d55-7608-9a21-06f15887001a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/texas/corpus-christi?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=119820847340712135&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "27.7376934",
      "poi_longitude": "-97.4343433",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 361-854-9505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-d9cc-7110-b726-6a8e95ae6770.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-d9cc-7110-b726-6a8e95ae6770",
        "storage_key": "property/6737460151192622/019d0783-d9cc-7110-b726-6a8e95ae6770.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJU9K9OeNfaIYRx_BtAm2wqQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_14c1fbb9-2c90-4077-828f-bb73a94acb96",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "Golden Corral Buffet & Grill",
      "poi_type": "Restaurants",
      "poi_address": "5901 S Padre Island Dr, Corpus Christi, TX 78412, USA",
      "poi_short_description": "All-you-can-eat eatery with down-home-style chicken and other eats, plus a chocolate fountain and a salad bar.",
      "poi_long_description": "People say this buffet restaurant offers a wide variety of fresh foods, including steak, grilled chicken, and BBQ chicken, as well as a selection of desserts and ice cream. They also highlight the attentive and friendly staff, and the clean and well-stocked environment.\n\nOther reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-a371-7638-8b11-59bd2873580b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-a371-7638-8b11-59bd2873580b",
        "storage_key": "property/6737460151192622/019d0783-a371-7638-8b11-59bd2873580b.webp",
        "width": 960,
        "height": 721
      },
      "poi_business_url": "https://www.goldencorral.com/locations/938/golden-corral-s-padre-island-drive?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=938",
      "poi_directions_map_url": "https://maps.google.com/?cid=4053497494473251754&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "golden-corral-buffet--grill",
      "poi_latitude": "27.7039039",
      "poi_longitude": "-97.3647183",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 361-991-2838",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-d9cc-7110-b726-6a8e95ae6770.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-d9cc-7110-b726-6a8e95ae6770",
        "storage_key": "property/6737460151192622/019d0783-d9cc-7110-b726-6a8e95ae6770.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBbmj88L1aIYRqpsDsH7qQDg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_c5a7debe-f89d-4486-a032-759748fd5d9a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "La Palmera",
      "poi_type": "Shopping & Retail",
      "poi_address": "5488 S Padre Island Dr, Corpus Christi, TX 78411, USA",
      "poi_short_description": "Shopping mall with a food court and a variety of stores, plus an arcade and a Dave & Buster's.",
      "poi_long_description": "100+ shopping & dining options & occasional events make this stalwart enclosed mall a local staple.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-a3d5-76d1-a8be-3cac82e9ce45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-a3d5-76d1-a8be-3cac82e9ce45",
        "storage_key": "property/6737460151192622/019d0783-a3d5-76d1-a8be-3cac82e9ce45.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.lapalmera.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3120543111874921680&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "la-palmera",
      "poi_latitude": "27.7111058",
      "poi_longitude": "-97.3727431",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 361-991-3755",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-d9cd-72e5-a5a6-14bbcdb4e6cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-d9cd-72e5-a5a6-14bbcdb4e6cf",
        "storage_key": "property/6737460151192622/019d0783-d9cd-72e5-a5a6-14bbcdb4e6cf.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJRamtmbn1aIYR0MSYSW1lTis",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_067fd904-4ac7-455e-8447-55d177e40f32",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "4717 S Padre Island Dr, Corpus Christi, TX 78411, USA",
      "poi_short_description": "Chain store carrying brand-name clothing and home goods for less.",
      "poi_long_description": "People say this clothing store offers a wide selection of cool items. They also highlight the affordable prices and convenient late hours.\n\nOther reviews mention the checkout lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-a39b-7141-9dcf-159ec5b188d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-a39b-7141-9dcf-159ec5b188d0",
        "storage_key": "property/6737460151192622/019d0783-a39b-7141-9dcf-159ec5b188d0.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10187196808982880831&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "27.7139711",
      "poi_longitude": "-97.3869578",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 361-854-9120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-d9cd-72e5-a5a6-14bbcdb4e6cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-d9cd-72e5-a5a6-14bbcdb4e6cf",
        "storage_key": "property/6737460151192622/019d0783-d9cd-72e5-a5a6-14bbcdb4e6cf.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJWfo4Zr1aIYRP-JqEIYxYI0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_d33f335a-301f-4377-9e64-f38a4dade78a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "4038 S Port Ave, Corpus Christi, TX 78415, USA",
      "poi_short_description": "Chain store stocking tools and home-improvement supplies.",
      "poi_long_description": "People say this home improvement store offers a large selection of tools and materials, including lattice in various styles and materials. They also highlight the helpful staff and friendly service.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-a947-763d-a41e-52eccfa5cf3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-a947-763d-a41e-52eccfa5cf3d",
        "storage_key": "property/6737460151192622/019d0783-a947-763d-a41e-52eccfa5cf3d.webp",
        "width": 622,
        "height": 1280
      },
      "poi_business_url": "https://www.homedepot.com/l/Bridgepoint/TX/Corpus-Christi/78415/6584?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=16957549818113943382&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "27.7554281",
      "poi_longitude": "-97.4183639",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 361-853-9173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-d9cd-72e5-a5a6-14bbcdb4e6cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-d9cd-72e5-a5a6-14bbcdb4e6cf",
        "storage_key": "property/6737460151192622/019d0783-d9cd-72e5-a5a6-14bbcdb4e6cf.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJYRmRzcBfaIYRVuer8bZRVes",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_5e853554-8d56-48ce-85a2-79cf08f99d8d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "H-E-B",
      "poi_type": "Shopping & Retail",
      "poi_address": "5425 S Staples St, Corpus Christi, TX 78411, USA",
      "poi_short_description": "Chain grocery outpost offering produce, prepared foods, and organic products, plus a pharmacy.",
      "poi_long_description": "People say this grocery store offers fresh produce and a wide selection of products. They highlight the great prices and convenient shopping experience. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-a956-72f9-bee1-da0c95458b7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-a956-72f9-bee1-da0c95458b7e",
        "storage_key": "property/6737460151192622/019d0783-a956-72f9-bee1-da0c95458b7e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/corpus-christi/moore-plaza-h-e-b-270?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=14997273651521046204&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "27.7060657",
      "poi_longitude": "-97.3723515",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 361-991-2695",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-d9d2-718b-a462-40eb75bda8ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-d9d2-718b-a462-40eb75bda8ba",
        "storage_key": "property/6737460151192622/019d0783-d9d2-718b-a462-40eb75bda8ba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb58lmer1aIYRvMY8Vu0EIdA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_0479c216-17c8-4594-a01a-50c3623596a9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "Del Mar College Heritage Campus",
      "poi_type": "Education",
      "poi_address": "101 Baldwin Blvd, Corpus Christi, TX 78404, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-a9a2-7785-937e-db90e265dbbc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-a9a2-7785-937e-db90e265dbbc",
        "storage_key": "property/6737460151192622/019d0783-a9a2-7785-937e-db90e265dbbc.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://delmar.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6850532147498623791&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "del-mar-college-heritage-campus",
      "poi_latitude": "27.7635746",
      "poi_longitude": "-97.4076327",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 361-698-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-d9cd-72e5-a5a6-1b9db0586009.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-d9cd-72e5-a5a6-1b9db0586009",
        "storage_key": "property/6737460151192622/019d0783-d9cd-72e5-a5a6-1b9db0586009.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ36SBiLFfaIYRL6MMRrH6EV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_8003a3c8-89ba-4229-b2b7-aab31890a0e8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "Del Mar College Windward Campus",
      "poi_type": "Education",
      "poi_address": "4101 Old Brownsville Rd, Corpus Christi, TX 78405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-aad2-73e8-9c7b-9dc129c02b7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-aad2-73e8-9c7b-9dc129c02b7d",
        "storage_key": "property/6737460151192622/019d0783-aad2-73e8-9c7b-9dc129c02b7d.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://www.delmar.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2616579146604629099&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "del-mar-college-windward-campus",
      "poi_latitude": "27.775239",
      "poi_longitude": "-97.441233",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 361-698-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-d9cd-72e5-a5a6-1b9db0586009.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-d9cd-72e5-a5a6-1b9db0586009",
        "storage_key": "property/6737460151192622/019d0783-d9cd-72e5-a5a6-1b9db0586009.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJu4I4D4FgaIYRa0wQ4N70TyQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_5c55b051-8fe9-4251-aea5-70a858d83e49",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "Texas State Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "2710 N Shoreline Blvd, Corpus Christi, TX 78402, USA",
      "poi_short_description": "Educational sea-life center for sharks sea turtles, dolphins and flamingoes plus a 4-D cinema and splash pad.",
      "poi_long_description": "Visitors say this aquarium offers a fun, family-friendly experience with exciting dolphin shows, stingray feeding, and a newly remodeled splash pad. They also highlight the knowledgeable and friendly staff, and many recommend purchasing a membership for unlimited visits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-af0b-739a-9822-c5168cffb363.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-af0b-739a-9822-c5168cffb363",
        "storage_key": "property/6737460151192622/019d0783-af0b-739a-9822-c5168cffb363.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.texasstateaquarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7716862830661101721&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "texas-state-aquarium",
      "poi_latitude": "27.813759",
      "poi_longitude": "-97.3919688",
      "poi_miles_from_property": "19.6",
      "poi_walking_minutes": "7 hours 6 mins",
      "poi_biking_minutes": "2 hours 3 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 361-881-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-de5d-75ae-ac4b-a9d857e338a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-de5d-75ae-ac4b-a9d857e338a6",
        "storage_key": "property/6737460151192622/019d0783-de5d-75ae-ac4b-a9d857e338a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmwHB2IZeaIYRmWj42dvNF2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_e42daeaa-63bc-4fd5-93f5-dda2bfe13dfd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "USS Lexington",
      "poi_type": "Entertainment",
      "poi_address": "2914 N Shoreline Blvd, Corpus Christi, TX 78402, USA",
      "poi_short_description": "Museum aboard a World War II-era aircraft carrier containing exhibits and simulators as well as a 3D theater.",
      "poi_long_description": "People say this museum offers a variety of exhibits, including planes, a flight simulator, and an escape room, and provides a glimpse into naval and military history. They highlight the fair admission price, the fun photo opportunities, and the self-guided tours. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-af25-767a-a8e0-6ca6c6c0ea6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-af25-767a-a8e0-6ca6c6c0ea6c",
        "storage_key": "property/6737460151192622/019d0783-af25-767a-a8e0-6ca6c6c0ea6c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.usslexington.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14440964187845462220&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "uss-lexington",
      "poi_latitude": "27.8150729",
      "poi_longitude": "-97.3887026",
      "poi_miles_from_property": "19.6",
      "poi_walking_minutes": "7 hours 6 mins",
      "poi_biking_minutes": "2 hours 3 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 361-888-4873",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-de73-7437-8cb0-03618812d199.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-de73-7437-8cb0-03618812d199",
        "storage_key": "property/6737460151192622/019d0783-de73-7437-8cb0-03618812d199.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJcZSFaoFeaIYRzIiq1mqcaMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_d716c66f-0eb5-4952-afe9-f8ac2cb292d2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "Selena Museum",
      "poi_type": "Entertainment",
      "poi_address": "5410 Leopard St, Corpus Christi, TX 78408, USA",
      "poi_short_description": "Museum at the late Tejano music singer Selena's former recording studio with tours and a gift shop.",
      "poi_long_description": "People say this museum offers a glimpse into Selena's life through a collection of her personal memorabilia, including outfits, awards, and photos. They highlight the affordable price, the sentimental and beautiful tribute, and the opportunity to see the recording studio. They also like the friendly staff and the gift shop with cool gear. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-b001-7654-beaf-39d96fe7042f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-b001-7654-beaf-39d96fe7042f",
        "storage_key": "property/6737460151192622/019d0783-b001-7654-beaf-39d96fe7042f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://q-productions.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3458229468224978244&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "selena-museum",
      "poi_latitude": "27.7981622",
      "poi_longitude": "-97.4612901",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 361-289-9013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-de73-7437-8cb0-03618812d199.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-de73-7437-8cb0-03618812d199",
        "storage_key": "property/6737460151192622/019d0783-de73-7437-8cb0-03618812d199.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ6UHlMBgaIYRRH1W_WAZ_i8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_a2592707-38d9-4133-8c13-118ca29c6d89",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "American Bank Center",
      "poi_type": "Entertainment",
      "poi_address": "1901 N Shoreline Blvd, Corpus Christi, TX 78401, USA",
      "poi_short_description": "Large venue hosting concerts, trade shows and sports events.",
      "poi_long_description": "People say this arena is a great place for concerts, graduations, and conferences. They also highlight the clean facilities, spacious seating, and friendly staff.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-b0e5-742c-aadf-c9affaeae419.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-b0e5-742c-aadf-c9affaeae419",
        "storage_key": "property/6737460151192622/019d0783-b0e5-742c-aadf-c9affaeae419.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://hilliardcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=327909963533612703&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "american-bank-center",
      "poi_latitude": "27.8084147",
      "poi_longitude": "-97.3937165",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 361-826-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-de5d-75ae-ac4b-a9d857e338a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-de5d-75ae-ac4b-a9d857e338a6",
        "storage_key": "property/6737460151192622/019d0783-de5d-75ae-ac4b-a9d857e338a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfUdgOYheaIYRn3a73l_4jAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_84da31fa-7b80-4e9c-ab0e-61aa665f7d3e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "Whataburger Field",
      "poi_type": "Entertainment",
      "poi_address": "734 E Port Ave, Corpus Christi, TX 78401, USA",
      "poi_short_description": "Minor-league stadium, also used as a concert venue. Beer and BBQ fare are on the menu, too.",
      "poi_long_description": "People say this ballpark offers a fun and casual experience with plenty of food and drink options. They highlight the reasonable prices, especially on nights with food promotions, and the cool breeze coming off the water. They also like the friendly and helpful staff, and the clean and well-maintained facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-b538-768d-9dfc-5479be2db8c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-b538-768d-9dfc-5479be2db8c2",
        "storage_key": "property/6737460151192622/019d0783-b538-768d-9dfc-5479be2db8c2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.milb.com/corpus-christi/ballpark",
      "poi_directions_map_url": "https://maps.google.com/?cid=12590588292443136395&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "whataburger-field",
      "poi_latitude": "27.8098904",
      "poi_longitude": "-97.3993799",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-de84-709b-815c-37f3f7ce226b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-de84-709b-815c-37f3f7ce226b",
        "storage_key": "property/6737460151192622/019d0783-de84-709b-815c-37f3f7ce226b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfYpQvHxeaIYRi-FDHFjBuq4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_30392089-0cb0-4363-b4c4-ef190fa4d7e5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4222 S Staples St, Corpus Christi, TX 78411, USA",
      "poi_short_description": "Tanning, massage and tanning beds are among the amenities at this 24-hr health club.",
      "poi_long_description": "People say this gym has a great selection of new workout machines and is exceptionally clean. They also highlight the friendly and helpful staff, and the overall positive and welcoming atmosphere.\n\nSome reviews mention the equipment can be unreliable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-b523-720d-83fd-024e330eb507.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-b523-720d-83fd-024e330eb507",
        "storage_key": "property/6737460151192622/019d0783-b523-720d-83fd-024e330eb507.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/corpus-christi-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=3260924507456455843&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "27.7241372",
      "poi_longitude": "-97.3763473",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 361-993-4444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-de5d-75ae-ac4b-a9d857e338a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-de5d-75ae-ac4b-a9d857e338a6",
        "storage_key": "property/6737460151192622/019d0783-de5d-75ae-ac4b-a9d857e338a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs_150On1aIYRo8RO-o8hQS0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_364966a1-206b-4386-a74b-dcbf107e7333",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "Crunch Fitness - Corpus Christi",
      "poi_type": "Health and Wellness",
      "poi_address": "4108 S Staples St, Corpus Christi, TX 78411, USA",
      "poi_short_description": "Chain gym featuring tanning and massage, group fitness classes, and personal training.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and weights. They also highlight the clean facilities and friendly staff.\n\nOther reviews mention the management can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-b772-745d-aab0-c2cb6e0d85a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-b772-745d-aab0-c2cb6e0d85a6",
        "storage_key": "property/6737460151192622/019d0783-b772-745d-aab0-c2cb6e0d85a6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.crunch.com/locations/corpus-christi",
      "poi_directions_map_url": "https://maps.google.com/?cid=8966485304793013882&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "crunch-fitness---corpus-christi",
      "poi_latitude": "27.7291512",
      "poi_longitude": "-97.3795344",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 361-271-3099",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-de5d-75ae-ac4b-a9d857e338a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-de5d-75ae-ac4b-a9d857e338a6",
        "storage_key": "property/6737460151192622/019d0783-de5d-75ae-ac4b-a9d857e338a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu-GP7PFfaIYRep7y0-Bab3w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4690fe5d-370f-4bbe-b849-2280c100bb9a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "First Class Barber Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "5765 S Staples St, Corpus Christi, TX 78413, USA",
      "poi_short_description": "Primary services include barbering, and customers appreciate the atmosphere.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-bb4e-724a-927c-cd02b646bfb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-bb4e-724a-927c-cd02b646bfb0",
        "storage_key": "property/6737460151192622/019d0783-bb4e-724a-927c-cd02b646bfb0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8914303380606445363&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "first-class-barber-studio",
      "poi_latitude": "27.696513",
      "poi_longitude": "-97.377558",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 361-442-2312",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-de5d-75ae-ac4b-a9d857e338a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-de5d-75ae-ac4b-a9d857e338a6",
        "storage_key": "property/6737460151192622/019d0783-de5d-75ae-ac4b-a9d857e338a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGYp0bPr3aIYRM2cc1bH3tXs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_5d699b63-93cd-477e-9011-5bc4abfff612",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "Freedom Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3231 S Alameda St, Corpus Christi, TX 78404, USA",
      "poi_short_description": "Clean gym with weights and machines, plus classes and massage.",
      "poi_long_description": "People say this gym offers a variety of workout options, including a women's center. They also highlight the friendly and helpful staff, and the laid-back vibe.\n\nOther reviews mention the gym can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-bb20-732e-bf0c-f1723824a7f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-bb20-732e-bf0c-f1723824a7f0",
        "storage_key": "property/6737460151192622/019d0783-bb20-732e-bf0c-f1723824a7f0.webp",
        "width": 578,
        "height": 385
      },
      "poi_business_url": "https://freedomfitness.com/corpus-christi-alameda/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13443624175356248672&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "freedom-fitness",
      "poi_latitude": "27.7557206",
      "poi_longitude": "-97.3899764",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 361-334-4250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-de5d-75ae-ac4b-a9d857e338a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-de5d-75ae-ac4b-a9d857e338a6",
        "storage_key": "property/6737460151192622/019d0783-de5d-75ae-ac4b-a9d857e338a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgdXVCwxfaIYRYIL2yfVYkbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_377ed0f5-68e7-48a7-a041-9fd6df670e9b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "Mary Jane's Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "5102 Jean St, Corpus Christi, TX 78411, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-bd50-7051-8532-2b48f1598c4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-bd50-7051-8532-2b48f1598c4b",
        "storage_key": "property/6737460151192622/019d0783-bd50-7051-8532-2b48f1598c4b.webp",
        "width": 1280,
        "height": 828
      },
      "poi_business_url": "http://maryjanesgymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9557802749188500629&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "mary-janes-gymnastics",
      "poi_latitude": "27.7185373",
      "poi_longitude": "-97.3960672",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 361-814-0042",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-d9cd-72e5-a5a6-1b9db0586009.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-d9cd-72e5-a5a6-1b9db0586009",
        "storage_key": "property/6737460151192622/019d0783-d9cd-72e5-a5a6-1b9db0586009.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG0n5i3j1aIYRleyhAvYipIQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0ae3e692-455f-4be1-85b2-372d1731ac85",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "Doddridge Animal Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "4452 Gollihar Rd, Corpus Christi, TX 78411, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-bd39-77da-b031-0bee8be4dcf0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-bd39-77da-b031-0bee8be4dcf0",
        "storage_key": "property/6737460151192622/019d0783-bd39-77da-b031-0bee8be4dcf0.webp",
        "width": 924,
        "height": 525
      },
      "poi_business_url": "https://www.doddridgeanimalclinic.com/?utm_source=gmb&utm_medium=organic&y_source=1_MTE2Njg3MjAtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=14870971141636786720&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "doddridge-animal-clinic",
      "poi_latitude": "27.7276398",
      "poi_longitude": "-97.3843397",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 361-852-9638",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-de5d-75ae-ac4b-a9d857e338a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-de5d-75ae-ac4b-a9d857e338a6",
        "storage_key": "property/6737460151192622/019d0783-de5d-75ae-ac4b-a9d857e338a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTbUmj3BfaIYRIIpYqnZNYM4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_8d6706c4-b02f-4ea1-b107-69ed0c596146",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "Everhart Animal Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "4232 S Padre Island Dr, Corpus Christi, TX 78411, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-c111-7744-a2cd-1d578a1ced7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-c111-7744-a2cd-1d578a1ced7a",
        "storage_key": "property/6737460151192622/019d0783-c111-7744-a2cd-1d578a1ced7a.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://everhartah.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5353707275704480793&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "everhart-animal-hospital",
      "poi_latitude": "27.7198",
      "poi_longitude": "-97.393477",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 361-854-1439",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-de5d-75ae-ac4b-a9d857e338a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-de5d-75ae-ac4b-a9d857e338a6",
        "storage_key": "property/6737460151192622/019d0783-de5d-75ae-ac4b-a9d857e338a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1QS7QYL1aIYRGTTK72YwTEo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_a60d283b-55c6-4187-815c-a1d064be87b9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "Great Clips",
      "poi_type": "Health and Wellness",
      "poi_address": "3133 S Alameda St Ste 480, Corpus Christi, TX 78404, USA",
      "poi_short_description": "Simple, airy salon chain offering haircuts for adults and kids, plus beard trims, styling and coloring.",
      "poi_long_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-c149-773e-8638-ae37e1e24b9c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-c149-773e-8638-ae37e1e24b9c",
        "storage_key": "property/6737460151192622/019d0783-c149-773e-8638-ae37e1e24b9c.webp",
        "width": 888,
        "height": 500
      },
      "poi_business_url": "https://salons.greatclips.com/us/tx/corpus-christi/3133-s-alameda-st?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=3422136900481519552&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "great-clips",
      "poi_latitude": "27.7568796",
      "poi_longitude": "-97.3917869",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 361-854-7328",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-de5d-75ae-ac4b-a9d857e338a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-de5d-75ae-ac4b-a9d857e338a6",
        "storage_key": "property/6737460151192622/019d0783-de5d-75ae-ac4b-a9d857e338a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3Y01dAlfaIYRwA_1NWHffS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_a15ed3ed-e94b-4f23-a1be-7b6c4ed12325",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "Driscoll Children's Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "3533 S Alameda St, Corpus Christi, TX 78411, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-c3ff-76cb-8cb7-923e659f96cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-c3ff-76cb-8cb7-923e659f96cc",
        "storage_key": "property/6737460151192622/019d0783-c3ff-76cb-8cb7-923e659f96cc.webp",
        "width": 1280,
        "height": 787
      },
      "poi_business_url": "https://www.driscollchildrens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5033822245450462085&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "driscoll-childrens-hospital",
      "poi_latitude": "27.7488804",
      "poi_longitude": "-97.3863616",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 361-694-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-df25-7561-a83d-b9c042bd9fba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-df25-7561-a83d-b9c042bd9fba",
        "storage_key": "property/6737460151192622/019d0783-df25-7561-a83d-b9c042bd9fba.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJg5RQInNfaIYRhbOIcqm620U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_2b73251f-90ed-4be1-aeff-68fd42442995",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "Corpus Christi Medical Center Doctors Regional",
      "poi_type": "Health and Wellness",
      "poi_address": "3315 S Alameda St, Corpus Christi, TX 78411, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-c6af-707f-9649-f497e2903124.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-c6af-707f-9649-f497e2903124",
        "storage_key": "property/6737460151192622/019d0783-c6af-707f-9649-f497e2903124.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://ccmedicalcenter.com/location/doctors-regional?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=12529314179520769762&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "corpus-christi-medical-center-doctors-regional",
      "poi_latitude": "27.7531114",
      "poi_longitude": "-97.3889859",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 361-761-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-df25-7561-a83d-b9c042bd9fba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-df25-7561-a83d-b9c042bd9fba",
        "storage_key": "property/6737460151192622/019d0783-df25-7561-a83d-b9c042bd9fba.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8ej6XwxfaIYR4q6Z9dwQ4a0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_424e8530-e7b5-4142-b91e-59447d807084",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "Cole Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2600 Ocean Dr, Corpus Christi, TX 78404, USA",
      "poi_short_description": "Family-friendly park featuring a playground and a pier.",
      "poi_long_description": "People say this city park offers a pier with seating, a skate park, a splash pad, a playground, and a walking/jogging trail. They highlight the beautiful scenery, the relaxing and peaceful vibe, and the family-friendly atmosphere. They also like the availability of tables, restrooms, and parking, as well as the presence of food trucks and opportunities for fishing. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-c7ca-7368-907e-c1ec296ac5d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-c7ca-7368-907e-c1ec296ac5d8",
        "storage_key": "property/6737460151192622/019d0783-c7ca-7368-907e-c1ec296ac5d8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.visitcorpuschristitx.org/see-and-do/2065/cole-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1320172733089267574&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "cole-park",
      "poi_latitude": "27.7731984",
      "poi_longitude": "-97.3899019",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 361-826-3460",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-e2ab-7447-b302-7021f9509381.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-e2ab-7447-b302-7021f9509381",
        "storage_key": "property/6737460151192622/019d0783-e2ab-7447-b302-7021f9509381.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJBYKbRwJfaIYRdj_xLRsyUhI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_94164d73-d62f-41ca-a8fd-774217e33780",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "Lozano Golf Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4401 Old Brownsville Rd, Corpus Christi, TX 78405, USA",
      "poi_short_description": "Popular facility featuring an 18-hole championship course with bunkers and water hazards.",
      "poi_long_description": "People say this golf course offers a driving range, a night golf par 3 course, and greens with bunkers. They highlight the reasonable prices and the well-maintained greens. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-c9b7-7554-90a8-9951027d88f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-c9b7-7554-90a8-9951027d88f1",
        "storage_key": "property/6737460151192622/019d0783-c9b7-7554-90a8-9951027d88f1.webp",
        "width": 1280,
        "height": 434
      },
      "poi_business_url": "http://lozanogolfcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9054355566216249246&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "lozano-golf-center",
      "poi_latitude": "27.7680507",
      "poi_longitude": "-97.4429322",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 361-826-8017",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-e35a-77eb-891d-1ae5b78e0516.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-e35a-77eb-891d-1ae5b78e0516",
        "storage_key": "property/6737460151192622/019d0783-e35a-77eb-891d-1ae5b78e0516.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJT1YbaXxgaIYRnn9mWmqIp30",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_b367184d-cb92-46fa-998c-d5e0d3679494",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "Oso Beach Municipal Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5601 S Alameda St, Corpus Christi, TX 78412, USA",
      "poi_short_description": "Flat course featuring bunkers, lakes and tree-lined fairways, plus greens with rolling slopes.",
      "poi_long_description": "People say this golf course offers well-maintained greens and a fun playing experience. They also highlight the friendly and accommodating staff, and the clean, well-functioning carts.\n\nOther reviews mention the wind can be strong.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-ca53-744f-a4d0-3dc13fbac1a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-ca53-744f-a4d0-3dc13fbac1a2",
        "storage_key": "property/6737460151192622/019d0783-ca53-744f-a4d0-3dc13fbac1a2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://osobeachgolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=287600427832555060&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "oso-beach-municipal-golf-course",
      "poi_latitude": "27.7133825",
      "poi_longitude": "-97.3480209",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 361-826-8010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-e35a-77eb-891d-1ae5b78e0516.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-e35a-77eb-891d-1ae5b78e0516",
        "storage_key": "property/6737460151192622/019d0783-e35a-77eb-891d-1ae5b78e0516.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ--WNRwn2aIYRNLY1uhDD_QM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_bb3c7c2d-0714-4fc3-a90c-66b35127bedb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "Water's Edge Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "602 S Shoreline Blvd, Corpus Christi, TX 78401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-cced-7490-ae56-e51c5a43c606.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-cced-7490-ae56-e51c5a43c606",
        "storage_key": "property/6737460151192622/019d0783-cced-7490-ae56-e51c5a43c606.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ccparkandrec.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12660537239203747650&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "waters-edge-park",
      "poi_latitude": "27.789704",
      "poi_longitude": "-97.3935383",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 361-826-3460",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-e2ab-7447-b302-7021f9509381.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-e2ab-7447-b302-7021f9509381",
        "storage_key": "property/6737460151192622/019d0783-e2ab-7447-b302-7021f9509381.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4XsE-PdeaIYRQhdYaIpDs68",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b79b6131-62f3-467f-a9f3-d1f1a3c278f4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "Heritage Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1581 N Chaparral St, Corpus Christi, TX 78401, USA",
      "poi_short_description": "City park featuring historical houses, markets, and events, such as a monthly market and a jazz festival.",
      "poi_long_description": "Popular site with several Victorian homes, some offering tours, plus space for picnics & festivals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-cdee-7551-8526-73957917032f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-cdee-7551-8526-73957917032f",
        "storage_key": "property/6737460151192622/019d0783-cdee-7551-8526-73957917032f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.cctexas.com/services/general-government/heritage-park-cultural-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=16038072882727207588&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "heritage-park",
      "poi_latitude": "27.8063352",
      "poi_longitude": "-97.395775",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 361-826-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-e2ab-7447-b302-7021f9509381.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-e2ab-7447-b302-7021f9509381",
        "storage_key": "property/6737460151192622/019d0783-e2ab-7447-b302-7021f9509381.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQfsrgWJeaIYRpMLHQFCukt4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bc9a2872-d6dd-4535-bcdf-60c45cc725db",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "Cabaniss Field NOLF",
      "poi_type": "Transportation & Transit",
      "poi_address": "Corpus Christi, TX 78415, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18281542556473788835&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "cabaniss-field-nolf",
      "poi_latitude": "27.7043314",
      "poi_longitude": "-97.4404172",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-e378-72d8-95fd-083b737caaae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-e378-72d8-95fd-083b737caaae",
        "storage_key": "property/6737460151192622/019d0783-e378-72d8-95fd-083b737caaae.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJeb7CRbWKaIYRo4nOaBgWtf0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_55be65f3-85a6-4324-9e3d-7043d299a355",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "City of Corpus Christi - City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1201 Leopard St, Corpus Christi, TX 78401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-d085-732c-a043-31f38b7512b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-d085-732c-a043-31f38b7512b3",
        "storage_key": "property/6737460151192622/019d0783-d085-732c-a043-31f38b7512b3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cctexas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18069329126635885507&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "city-of-corpus-christi---city-hall",
      "poi_latitude": "27.7958165",
      "poi_longitude": "-97.4042341",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 361-826-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-e3d7-72ae-bdff-456205f2b5a0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-e3d7-72ae-bdff-456205f2b5a0",
        "storage_key": "property/6737460151192622/019d0783-e3d7-72ae-bdff-456205f2b5a0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWe7TFF1eaIYRw1PA8honw_o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_dac0ed22-e7a9-4f3a-b21e-5fca8caec25f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "Corpus Christi District Parole Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "422 Sun Belt Dr, Corpus Christi, TX 78408, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-d07b-71c1-be51-192329b10a89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-d07b-71c1-be51-192329b10a89",
        "storage_key": "property/6737460151192622/019d0783-d07b-71c1-be51-192329b10a89.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.tdcj.texas.gov/divisions/pd/region_4_dpo.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=390193573637690009&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "corpus-christi-district-parole-office",
      "poi_latitude": "27.7946968",
      "poi_longitude": "-97.4574584",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 361-888-5698",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-de5d-75ae-ac4b-a9d857e338a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-de5d-75ae-ac4b-a9d857e338a6",
        "storage_key": "property/6737460151192622/019d0783-de5d-75ae-ac4b-a9d857e338a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC3SSJr5gaIYRmZJQ5vw-agU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_93a2c59b-121d-43ad-8bca-e6a43be9e42a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "Port of Corpus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Stroman Rd, Corpus Christi, TX 78401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-d2f5-75ed-8c05-dc626009f817.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-d2f5-75ed-8c05-dc626009f817",
        "storage_key": "property/6737460151192622/019d0783-d2f5-75ed-8c05-dc626009f817.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14650378364965125825&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "port-of-corpus",
      "poi_latitude": "27.810996",
      "poi_longitude": "-97.405933",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-de5d-75ae-ac4b-a9d857e338a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-de5d-75ae-ac4b-a9d857e338a6",
        "storage_key": "property/6737460151192622/019d0783-de5d-75ae-ac4b-a9d857e338a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLSPBfnBeaIYRwX7QfICZUMs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_19fc1c19-d13d-427d-82ef-4b9ba31fa41b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "Coast Guard",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1201 north navigation, Corpus Christi, TX 78407, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-d3f1-76bd-8eed-e4558372ec46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0783-d3f1-76bd-8eed-e4558372ec46",
        "storage_key": "property/6737460151192622/019d0783-d3f1-76bd-8eed-e4558372ec46.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8229489161914342030&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "coast-guard",
      "poi_latitude": "27.8153706",
      "poi_longitude": "-97.4054373",
      "poi_miles_from_property": "18.5",
      "poi_walking_minutes": "6 hours 42 mins",
      "poi_biking_minutes": "1 hour 58 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-de5d-75ae-ac4b-a9d857e338a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-de5d-75ae-ac4b-a9d857e338a6",
        "storage_key": "property/6737460151192622/019d0783-de5d-75ae-ac4b-a9d857e338a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdfJW4XleaIYRjtrUgsoENXI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_faa30da5-63d2-457c-8b0d-27432d2b27d8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "poi_name": "Valero Refining Training",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5441 Up River Rd, Corpus Christi, TX 78407, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9534675132440056154&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRAAGAQgAA",
      "poi_item_slug": "valero-refining-training",
      "poi_latitude": "27.8100938",
      "poi_longitude": "-97.4589546",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-de5d-75ae-ac4b-a9d857e338a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0783-de5d-75ae-ac4b-a9d857e338a6",
        "storage_key": "property/6737460151192622/019d0783-de5d-75ae-ac4b-a9d857e338a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8w-ya2FhaIYRWhHXHYT4UYQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_f15aa2a0-b6c0-4dd9-8e45-c12884846de7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_442b6dbb-8f9b-4f8f-b290-2d6772badc55",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_61e507b5-06b6-4e82-b7c8-1badc698d0a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_1de0c42c-578a-4bdf-8df1-673159ed20d7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_49720922-2552-4e8d-99f0-b521eeb47ea0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d74f7724-9d11-4598-98b0-7a75596b5cd8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_a9bd0b94-b9de-4641-b6cb-2b78e3094f7f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "rating": "5",
      "name": "K Garrison",
      "text": "We been here since early 2019 and had a great experience. We have met so many great people and pets that made our time here enjoyable. We are excited for our next chapter, and grateful for the Bay Vista community and staff for the memories!",
      "date": "2026-03-06",
      "title": "false"
    },
    {
      "id": "custom_f5c581ab-4e8e-43ce-afc4-c5b309162296",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "rating": "5",
      "name": "Jose Villanueva",
      "text": "⭐️⭐️⭐️⭐️⭐️",
      "date": "2025-12-05",
      "title": "false"
    },
    {
      "id": "custom_36456723-60df-42de-abce-789f5b441b16",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "rating": "5",
      "name": "Jamal Dawson",
      "text": "Very welcoming and hard working!!! Thank you Lisa E!!",
      "date": "2025-07-25",
      "title": "false"
    },
    {
      "id": "custom_ad22a8f8-f873-4372-8c1d-64ee81854ab6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "rating": "5",
      "name": "Reana Hinojosa",
      "text": "We had such a great experience with Lisa E.! From the moment we connected with her, she made the leasing process incredibly smooth and stress-free. She helped us get approved quickly, answered all our questions with patience and clarity, and kept us informed every step of the way. Thanks to her, the whole process was fast, easy, and actually enjoyable. We’re so excited to move in and officially become residents! Lisa truly went above and beyond—highly recommend her!☺️",
      "date": "2025-07-25",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_91472210-0f48-4116-8c25-9cf7971f7ee4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019e1e00-2396-75f5-ba47-5a37368873de.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1e00-2396-75f5-ba47-5a37368873de",
        "storage_key": "property/6737460151192622/019e1e00-2396-75f5-ba47-5a37368873de.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "2 Bed | 2 Bath",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=6849736caf6f144c26869177"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019910d4-60e1-74ef-842e-462c55f6241a",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Bay Vista Apartments property website",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622"
    },
    {
      "lead_collector_id": "019910d4-614f-75a9-abba-a84309df62dc",
      "lead_source": "FACEBOOK_ADS",
      "name": "Bay Vista Apartments facebook ads",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622"
    },
    {
      "lead_collector_id": "019910d4-61c3-710a-8a6e-92e1c4f9b8c3",
      "lead_source": "LANDING_PAGE",
      "name": "Bay Vista Apartments landing page",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-corpus-christi-bay-vista",
      "search_query": "apartments with in-unit laundry corpus christi tx",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry Options",
      "h2_subtitle": "Discover spacious apartments with in-unit laundry in Corpus Christi, TX. Enjoy modern comforts at Bay Vista's pet-friendly community.",
      "page_copy": "Welcome to Bay Vista Apartments in downtown Corpus Christi, where modern convenience meets unmatched comfort. Our selection of studio, one, and two-bedroom units not only offers ample living space but also features in-unit laundry setups, making daily chores a breeze. Experience a vibrant lifestyle enriched by amenities such as a well-equipped business center, lush pet-friendly areas, and serene sunrooms.\n\nNestled in the heart of Corpus Christi, Bay Vista elevates apartment living with convenience and style. Savor leisure time at the picnic area or take advantage of our dedicated recycling facilities, all within a stone's throw from your apartment with in-unit laundry. Join us in a community where prime location meets exceptional amenities, and schedule your personalized tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-9065-7569-972e-dc0aa16e6b09.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with waterfall feature and lounge chairs next to apartment building.",
        "public_id": "019d0783-9065-7569-972e-dc0aa16e6b09",
        "storage_key": "property/6737460151192622/019d0783-9065-7569-972e-dc0aa16e6b09.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry in Corpus Christi",
      "seo_description": "Explore Bay Vista Apartments offering in-unit laundry in Corpus Christi, TX. Enjoy modern amenities and prime location. Schedule a tour now!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "page_item_url": "pet-friendly-dog-park-apartments-downtown-corpus-christi",
      "search_query": "pet-friendly apartments with dog park in downtown corpus christi",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Downtown Corpus Christi",
      "h2_subtitle": "Discover pet-friendly apartments featuring a dog park in downtown Corpus Christi. Bay Vista offers a welcoming home for you and your furry friends.",
      "page_copy": "Experience the perfect blend of urban living and pet-friendly features at Bay Vista Apartments in downtown Corpus Christi. Our property offers spacious floor plans complemented by a dedicated dog park, making it the ideal home for pet lovers. Enjoy comfortable living with a community that welcomes both you and your furry companions with open arms.\n\nBay Vista is more than just a place to live—it's a vibrant community. With amenities like a convenient business center, lush picnic areas, and sunlit rooms, there’s something for everyone. Our pet-friendly ethos ensures that your pets feel at home, while you enjoy all that downtown Corpus Christi has to offer. Schedule a tour today and see how Bay Vista Apartments meets all your lifestyle and pet needs!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-9065-7569-972e-dc0aa16e6b09.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with waterfall feature and lounge chairs next to apartment building.",
        "public_id": "019d0783-9065-7569-972e-dc0aa16e6b09",
        "storage_key": "property/6737460151192622/019d0783-9065-7569-972e-dc0aa16e6b09.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments with Dog Park Downtown",
      "seo_description": "Find pet-friendly living with a dog park at Bay Vista Apartments in downtown Corpus Christi. Ideal for you and your pets. Schedule a visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "page_item_url": "gated-community-apartments-pool-nueces-county",
      "search_query": "gated community apartments with pool nueces county",
      "category": "Amenity",
      "h1_title": "Gated Community Apartments with Pool",
      "h2_subtitle": "Explore gated community apartments with a pool in Nueces County. Bay Vista offers a secure and leisurely living experience in Corpus Christi.",
      "page_copy": "Welcome to the serene lifestyle at Bay Vista Apartments, a gated community nestled in vibrant Nueces County. Our pristine apartments provide an exclusive living experience, featuring a refreshing pool perfect for relaxation and recreation. Choose from our carefully designed studio, one, and two-bedroom units, each promoting comfort and modern living in the heart of Corpus Christi.\n\nBay Vista's commitment to excellence is demonstrated through our wide range of amenities. Enjoy peace of mind within our gated community, complemented by facilities such as a business center, lush picnic areas, and sunrooms that capture natural light. Dive into a lifestyle where security meets leisure at Bay Vista Apartments, and schedule a tour to explore our inviting community in Nueces County today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-9065-7569-972e-dc0aa16e6b09.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with waterfall feature and lounge chairs next to apartment building.",
        "public_id": "019d0783-9065-7569-972e-dc0aa16e6b09",
        "storage_key": "property/6737460151192622/019d0783-9065-7569-972e-dc0aa16e6b09.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Apartments with Pool in Nueces County",
      "seo_description": "Discover Bay Vista Apartments, a gated community in Nueces County featuring a pool. Experience comfortable and secure living. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-near-corpus-christi-78404",
      "search_query": "air conditioned apartments near corpus christi 78404",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments Near Corpus Christi",
      "h2_subtitle": "Find your perfect air-conditioned apartment near Corpus Christi, 78404. Bay Vista offers comfortable living with all modern conveniences.",
      "page_copy": "Discover the comfortable living spaces of Bay Vista Apartments, located near Corpus Christi in the 78404 area. Our air-conditioned apartments offer the perfect retreat from the Texas heat, ensuring you and your family stay cool and comfortable all year round. Choose from a variety of floor plans including studio, one, and two-bedroom options that are designed with your lifestyle in mind.\n\nSituated in a prime location, Bay Vista provides both convenience and serenity. Enjoy the community's well-rounded amenities such as a business center, picturesque picnic areas, and sunlit rooms that add a touch of warmth. Experience the ideal balance of modern living and relaxation at Bay Vista Apartments. Schedule a tour today and explore the welcoming environment waiting for you here near Corpus Christi.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-9065-7569-972e-dc0aa16e6b09.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with waterfall feature and lounge chairs next to apartment building.",
        "public_id": "019d0783-9065-7569-972e-dc0aa16e6b09",
        "storage_key": "property/6737460151192622/019d0783-9065-7569-972e-dc0aa16e6b09.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments Near Corpus Christi",
      "seo_description": "Explore air-conditioned living at Bay Vista Apartments near Corpus Christi, 78404. Comfort meets convenience. Schedule your tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "page_item_url": "luxury-apartments-dishwasher-corpus-christi-tx",
      "search_query": "luxury apartments with dishwasher corpus christi tx",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Dishwasher",
      "h2_subtitle": "Explore luxury apartments equipped with dishwashers in Corpus Christi, TX. Experience elevated living at Bay Vista Apartments.",
      "page_copy": "Experience premier living at Bay Vista Apartments in Corpus Christi, TX, where luxury meets convenience. Our well-appointed apartments come complete with modern dishwashers, streamlining your daily routine and enhancing the ease of living. Offering spacious layouts, choose from our studio, one, and two-bedroom floor plans that perfectly match your lifestyle needs.\n\nBay Vista is more than just about luxury interiors; it’s a community designed for your relaxation and enjoyment. Relish our top-tier amenities including a convenient business center, peaceful sunrooms, and family-friendly picnic areas. As part of our commitment to sustainable living, we also offer eco-friendly recycling options. Elevate your lifestyle at Bay Vista Apartments, and discover the perfect blend of luxury and practicality. Schedule a visit today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-9065-7569-972e-dc0aa16e6b09.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with waterfall feature and lounge chairs next to apartment building.",
        "public_id": "019d0783-9065-7569-972e-dc0aa16e6b09",
        "storage_key": "property/6737460151192622/019d0783-9065-7569-972e-dc0aa16e6b09.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Dishwasher in Corpus Christi",
      "seo_description": "Find luxury living with dishwashers at Bay Vista Apartments in Corpus Christi, TX. Modern amenities and comfort await. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-downtown-corpus-christi",
      "search_query": "one bedroom apartments downtown Corpus Christi",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments Downtown",
      "h2_subtitle": "Discover one-bedroom apartments in downtown Corpus Christi. Bay Vista offers stylish units with modern amenities in the heart of the city.",
      "page_copy": "Looking for a stylish one-bedroom apartment in the vibrant downtown Corpus Christi area? Bay Vista Apartments provides the perfect urban living solution, combining convenience with comfort. Each one-bedroom unit is thoughtfully designed to maximize space and functionality, with contemporary amenities that match your lifestyle.\n\nLocated in the heart of downtown, Bay Vista Apartments surrounds you with the lively culture and entertainment that Corpus Christi has to offer. Enjoy on-site amenities such as a business center where you can get work done, sunrooms filled with natural light, and scenic picnic areas perfect for leisurely weekends. Discover the dynamics of city living at Bay Vista by scheduling your personal tour today. Experience the seamless blend of modern design and downtown convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-9065-7569-972e-dc0aa16e6b09.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with waterfall feature and lounge chairs next to apartment building.",
        "public_id": "019d0783-9065-7569-972e-dc0aa16e6b09",
        "storage_key": "property/6737460151192622/019d0783-9065-7569-972e-dc0aa16e6b09.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Downtown Corpus Christi",
      "seo_description": "Explore one-bedroom options at Bay Vista Apartments, located downtown Corpus Christi. Modern designs and city-centric living await you!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-nueces-county",
      "search_query": "two bedroom apartments Nueces County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Nueces County",
      "h2_subtitle": "Find spacious two-bedroom apartments in Nueces County. Enjoy modern amenities and convenient living at Bay Vista Apartments.",
      "page_copy": "Discover the perfect two-bedroom apartment at Bay Vista Apartments, ideally situated in Nueces County. Our spacious two-bedroom units are designed to provide you with ample living space and modern comforts that cater to your everyday needs. Each apartment features innovative layouts and amenities that promote a comfortable and stylish lifestyle.\n\nNestled in the heart of Corpus Christi, Bay Vista Apartments offers a quiet retreat with convenient access to the vibrant city life. Amenities like walk-in closets, window coverings, and sunrooms cater to both functionality and relaxation. For families and professionals alike, our property offers a balanced living experience with easy proximity to local attractions and businesses. Schedule a tour today and step into the convenience and style of Bay Vista Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-9065-7569-972e-dc0aa16e6b09.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with waterfall feature and lounge chairs next to apartment building.",
        "public_id": "019d0783-9065-7569-972e-dc0aa16e6b09",
        "storage_key": "property/6737460151192622/019d0783-9065-7569-972e-dc0aa16e6b09.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Nueces County",
      "seo_description": "Explore spacious two-bedroom apartments at Bay Vista in Nueces County. Modern living with top amenities—schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "page_item_url": "studio-apartments-corpus-christi-tx",
      "search_query": "studio apartments Corpus Christi TX",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Corpus Christi, TX",
      "h2_subtitle": "Discover studio apartments in Corpus Christi, TX. Bay Vista Apartments offers modern studio living with convenient amenities.",
      "page_copy": "Explore the optimal studio apartment experience at Bay Vista Apartments in Corpus Christi, TX. Designed for modern living, our studio units offer a perfect blend of efficiency and comfort, catering to both singles and professionals seeking a dynamic living space. These thoughtfully arranged studios are compact yet spacious, furnished with contemporary features to make life easier.\n\nLocated in a vibrant community, Bay Vista Apartments boasts a host of amenities, including a welcoming business center, well-maintained picnic areas, and eco-friendly recycling options. Enjoy the vibrant lifestyle that comes with living in the heart of Corpus Christi, while basking in the comfort of a well-equipped studio apartment. Ready to find your ideal home? Contact us today and step into the convenience of Bay Vista Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-9065-7569-972e-dc0aa16e6b09.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with waterfall feature and lounge chairs next to apartment building.",
        "public_id": "019d0783-9065-7569-972e-dc0aa16e6b09",
        "storage_key": "property/6737460151192622/019d0783-9065-7569-972e-dc0aa16e6b09.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Corpus Christi, TX",
      "seo_description": "Find modern studio apartments at Bay Vista in Corpus Christi, TX. Enjoy efficient living with top amenities. Contact us for a tour!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "page_item_url": "apartments-near-del-mar-college-heritage-campus",
      "search_query": "apartments near del mar college heritage campus downtown corpus christi",
      "category": "School",
      "h1_title": "Apartments Near Del Mar College Heritage",
      "h2_subtitle": "Discover apartments near Del Mar College Heritage Campus in downtown Corpus Christi. Bay Vista Apartments offers convenient and stylish living.",
      "page_copy": "If you're looking for convenient apartments near Del Mar College Heritage Campus in downtown Corpus Christi, look no further than Bay Vista Apartments. Located just minutes away from the campus, our property offers an ideal living situation for students and faculty alike, blending academic convenience with modern comfort.\n\nBay Vista Apartments provide a range of amenities designed to enhance your living experience, including a business center for focused study sessions, sunrooms for relaxation, and shady picnic areas perfect for unwinding. Nestled in the bustling downtown area, you'll also have easy access to public transportation, entertainment, and dining options. Experience the seamless integration of academia and urban life by choosing Bay Vista Apartments as your new home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-9065-7569-972e-dc0aa16e6b09.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with waterfall feature and lounge chairs next to apartment building.",
        "public_id": "019d0783-9065-7569-972e-dc0aa16e6b09",
        "storage_key": "property/6737460151192622/019d0783-9065-7569-972e-dc0aa16e6b09.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Del Mar College Heritage Campus",
      "seo_description": "Find convenient living at Bay Vista Apartments, just minutes from Del Mar College Heritage Campus in downtown Corpus Christi.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "page_item_url": "bay-vista-apartments-near-del-mar-windward-campus",
      "search_query": "bay vista apartments close to del mar college windward campus nueces county",
      "category": "School",
      "h1_title": "Bay Vista Apts Near Del Mar Windward",
      "h2_subtitle": "Find Bay Vista Apartments conveniently close to Del Mar College Windward Campus. Enjoy living in Nueces County with easy campus access.",
      "page_copy": "Bay Vista Apartments offers the ideal living solution for those seeking proximity to Del Mar College Windward Campus in Nueces County. Our prime location ensures a quick and easy commute, making it perfect for students and faculty members who want to reside near the campus without sacrificing comfort and quality of life.\n\nChoose Bay Vista Apartments for a community that balances convenience and lifestyle. Residents enjoy access to amenities such as walk-in closets, a well-equipped business center, and vibrant common areas like picnic spaces. Situated within the bustling environment of Corpus Christi, living here also provides easy access to local dining, shopping, and cultural activities. Make Bay Vista Apartments your home and enjoy both academic and residential satisfaction.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-9065-7569-972e-dc0aa16e6b09.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with waterfall feature and lounge chairs next to apartment building.",
        "public_id": "019d0783-9065-7569-972e-dc0aa16e6b09",
        "storage_key": "property/6737460151192622/019d0783-9065-7569-972e-dc0aa16e6b09.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bay Vista Apts Near Del Mar Windward Campus",
      "seo_description": "Live near Del Mar College Windward Campus at Bay Vista Apartments in Nueces County. Discover convenient and comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "page_item_url": "apartments-near-driscoll-childrens-hospital",
      "search_query": "apartments near Driscoll Children's Hospital Corpus Christi",
      "category": "Hospital",
      "h1_title": "Apartments Near Driscoll Children's Hospital",
      "h2_subtitle": "Explore apartments near Driscoll Children's Hospital in Corpus Christi. Bay Vista Apartments offers convenient living near healthcare facilities.",
      "page_copy": "Looking for apartments near Driscoll Children's Hospital in Corpus Christi? Bay Vista Apartments provides a fantastic option for medical professionals, families, and anyone seeking proximity to this vital healthcare facility. With a location that ensures a quick commute, you can enjoy the convenience of living close to the hospital while savoring the comfort and amenities that Bay Vista offers.\n\nOur residents benefit from a plethora of features, including a business center, walk-in closets, and relaxing sunrooms perfect for unwinding after a long day. The vibrant community environment includes picnic areas that foster relaxation and social interaction. Reside at Bay Vista Apartments and experience the perfect blend of proximity and comfort, with all the perks of downtown Corpus Christi living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-9065-7569-972e-dc0aa16e6b09.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with waterfall feature and lounge chairs next to apartment building.",
        "public_id": "019d0783-9065-7569-972e-dc0aa16e6b09",
        "storage_key": "property/6737460151192622/019d0783-9065-7569-972e-dc0aa16e6b09.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Driscoll Children's Hospital",
      "seo_description": "Discover comfort at Bay Vista Apartments, located near Driscoll Children's Hospital in Corpus Christi, offering convenience and excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "page_item_url": "bay-vista-apartments-near-corpus-christi-medical-center",
      "search_query": "Bay Vista apartments close to Corpus Christi Medical Center Doctors Regional",
      "category": "Hospital",
      "h1_title": "Bay Vista Apts Near Corpus Christi Med Center",
      "h2_subtitle": "Discover Bay Vista Apartments, close to Corpus Christi Medical Center Doctors Regional. Enjoy exceptional living with easy access to healthcare.",
      "page_copy": "Bay Vista Apartments is an excellent choice for those looking for a residence close to Corpus Christi Medical Center Doctors Regional. Our strategic location offers residents seamless access to this key healthcare facility, making it ideal for healthcare professionals and patients' families looking for nearby accommodations.\n\nExperience a lifestyle that combines convenience and quality at Bay Vista Apartments. With amenities such as a well-equipped business center, spacious walk-in closets, and a soothing sunroom, you will find everything you need for a comfortable and convenient living experience. Additionally, our community is located in the heart of downtown Corpus Christi, offering easy access to a variety of dining, shopping, and entertainment options. Choose Bay Vista Apartments to enjoy the best of both proximity and lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-9065-7569-972e-dc0aa16e6b09.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with waterfall feature and lounge chairs next to apartment building.",
        "public_id": "019d0783-9065-7569-972e-dc0aa16e6b09",
        "storage_key": "property/6737460151192622/019d0783-9065-7569-972e-dc0aa16e6b09.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bay Vista Apts Near Corpus Christi Med Center",
      "seo_description": "Live near Corpus Christi Medical Center at Bay Vista Apartments. Enjoy comfort and convenience with easy access to healthcare facilities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "page_item_url": "bay-vista-apartments-near-cole-park",
      "search_query": "bay vista apartments near cole park corpus christi",
      "category": "Park",
      "h1_title": "Bay Vista Apts Near Cole Park Corpus Christi",
      "h2_subtitle": "Explore Bay Vista Apartments, conveniently located near Cole Park in Corpus Christi. Enjoy easy access to outdoor fun and community events.",
      "page_copy": "For those who want to enjoy one of Corpus Christi's finest recreational spaces, Bay Vista Apartments offers the perfect location near Cole Park. Just a short distance away, this vibrant park is ideal for outdoor activities like picnics, walks, or enjoying a concert at the amphitheater.\n\nBay Vista Apartments not only provides close proximity to Cole Park but also a range of amenities to enhance your living experience. Residents can enjoy spacious floor plans, a dedicated business center, and serene picnic areas. Our location in downtown Corpus Christi makes it easy to partake in local attractions and dining options. Choose Bay Vista Apartments for an enriching lifestyle that blends leisure and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-9065-7569-972e-dc0aa16e6b09.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with waterfall feature and lounge chairs next to apartment building.",
        "public_id": "019d0783-9065-7569-972e-dc0aa16e6b09",
        "storage_key": "property/6737460151192622/019d0783-9065-7569-972e-dc0aa16e6b09.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bay Vista Apts Near Cole Park Corpus Christi",
      "seo_description": "Experience life near Cole Park at Bay Vista Apartments in Corpus Christi. Enjoy nearby outdoor activities and a range of modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "page_item_url": "bay-vista-apartments-near-waters-edge-park",
      "search_query": "bay vista apartments close to water's edge park nueces county",
      "category": "Park",
      "h1_title": "Bay Vista Apts Near Water's Edge Park",
      "h2_subtitle": "Discover Bay Vista Apartments, just a short stroll from Water's Edge Park in Nueces County. Enjoy the blend of nature and modern living.",
      "page_copy": "Nestled near the beautiful Water's Edge Park, Bay Vista Apartments offer a prime location in Nueces County for those who appreciate the tranquility of waterfront living. The park serves as a perfect spot for outdoor activities like jogging, picnicking, and enjoying stunning sunset views over Corpus Christi Bay.\n\nBay Vista Apartments complement this idyllic setting with an array of fantastic amenities. Residents can take advantage of our business center, cozy sunrooms, and convenient picnic areas. Our location in downtown Corpus Christi ensures you're close to exciting entertainment, shopping, and dining options. Experience the balance of serene park-side life with the convenience of city living at Bay Vista Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-9065-7569-972e-dc0aa16e6b09.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with waterfall feature and lounge chairs next to apartment building.",
        "public_id": "019d0783-9065-7569-972e-dc0aa16e6b09",
        "storage_key": "property/6737460151192622/019d0783-9065-7569-972e-dc0aa16e6b09.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bay Vista Apts Near Water's Edge Park",
      "seo_description": "Live close to Water's Edge Park at Bay Vista Apartments in Nueces County. Enjoy the convenience of city life with serene park views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192622",
      "source": "generator",
      "page_item_url": "apartments-near-heritage-park",
      "search_query": "apartments near heritage park downtown corpus christi",
      "category": "Park",
      "h1_title": "Apts Near Heritage Park Downtown Corpus Christi",
      "h2_subtitle": "Explore apartments near Heritage Park in downtown Corpus Christi. Enjoy the rich history and vibrant culture just steps from your door.",
      "page_copy": "Situated near the historical Heritage Park, our apartments in downtown Corpus Christi offer residents an opportunity to live amidst the city’s rich past and vibrant present. This charming area is perfect for those who appreciate historical architecture and cultural events, making it a unique place to call home.\n\nOur community at Bay Vista Apartments ensures you are not just close to Heritage Park but also benefit from a wealth of amenities. With spacious floor plans, a serene sunroom, and walk-in closets, comfort is paramount. The downtown location gives easy access to a variety of cultural experiences, dining, and shopping, all while enjoying modern conveniences. Embrace history and contemporary living at our apartments near Heritage Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192622/019d0783-9065-7569-972e-dc0aa16e6b09.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with waterfall feature and lounge chairs next to apartment building.",
        "public_id": "019d0783-9065-7569-972e-dc0aa16e6b09",
        "storage_key": "property/6737460151192622/019d0783-9065-7569-972e-dc0aa16e6b09.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Heritage Park Downtown Corpus Christi",
      "seo_description": "Discover Bay Vista Apartments near Heritage Park in downtown Corpus Christi. Enjoy living surrounded by history and cultural attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3362"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483202"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4687858"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.bayvistaliving.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.bayvistaliving.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.bayvistaliving.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.bayvistaliving.com?utm_knock=w"
    },
    {
      "ID": "custom_knock_z_link",
      "type": "STRING",
      "value": "https://www.bayvistaliving.com?utm_knock=z"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-P844P2VC"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.bayvistaliving.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.bayvistaliving.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.bayvistaliving.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.bayvistaliving.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.bayvistaliving.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.bayvistaliving.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_z_title",
      "type": "STRING",
      "value": "Zillow"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "361-315-6928"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.bayvistaliving.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.bayvistaliving.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "361-282-1219"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.bayvistaliving.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.bayvistaliving.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.bayvistaliving.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.bayvistaliving.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "361-304-3932"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "361-304-3901"
    },
    {
      "ID": "custom_knock_z_number",
      "type": "STRING",
      "value": "361-405-6330"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "361-301-3118"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.bayvistaliving.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "361-301-2765"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "361-301-5859"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "361-594-6577"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "361-282-0808"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "361-348-8659"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.bayvistaliving.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "361-301-2585"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.bayvistaliving.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "361-213-9954"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.bayvistaliving.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "361-301-2605"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "361-314-7121"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.bayvistaliving.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "361-304-9344"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "361-314-2787"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "361-301-2769"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.bayvistaliving.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.bayvistaliving.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "361-314-2005"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321182085"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "361-301-2673"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "361-309-9792"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.bayvistaliving.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "e1c3a11eeb78d49e"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.bayvistaliving.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "361-282-2706"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.bayvistaliving.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "361-304-3872"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "361-315-7322"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.bayvistaliving.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "361-733-3163"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "361-315-6942"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "361-301-3272"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "361-301-2536"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.bayvistaliving.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151192622/019e60d3-39c6-73e4-8629-8b64c6ed108f.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "361-304-3847"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "361-348-8659"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3362",
  "custom_repli_id": "5028483202",
  "custom_realpage_id": "4687858",
  "custom_knock_a_link": "https://www.bayvistaliving.com?utm_knock=a",
  "custom_knock_g_link": "https://www.bayvistaliving.com?utm_knock=g",
  "custom_knock_r_link": "https://www.bayvistaliving.com?utm_knock=r",
  "custom_knock_w_link": "https://www.bayvistaliving.com?utm_knock=w",
  "custom_knock_z_link": "https://www.bayvistaliving.com?utm_knock=z",
  "custom_google_gtm_id": "GTM-P844P2VC",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.bayvistaliving.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.bayvistaliving.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.bayvistaliving.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.bayvistaliving.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.bayvistaliving.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.bayvistaliving.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_z_title": "Zillow",
  "custom_knock_a_number": "361-315-6928",
  "custom_knock_ads_link": "https://www.bayvistaliving.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.bayvistaliving.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "361-282-1219",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.bayvistaliving.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.bayvistaliving.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.bayvistaliving.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.bayvistaliving.com?utm_knock=psa",
  "custom_knock_r_number": "361-304-3932",
  "custom_knock_w_number": "361-304-3901",
  "custom_knock_z_number": "361-405-6330",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "361-301-3118",
  "custom_knock_amap_link": "https://www.bayvistaliving.com?utm_knock=amap",
  "custom_knock_ar_number": "361-301-2765",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "361-301-5859",
  "custom_knock_fb_number": "361-594-6577",
  "custom_knock_fl_number": "361-282-0808",
  "custom_knock_gp_number": "361-348-8659",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.bayvistaliving.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "full_stack",
  "custom_knock_ads_number": "361-301-2585",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.bayvistaliving.com?utm_knock=bcard",
  "custom_knock_bnr_number": "361-213-9954",
  "custom_knock_cfres_link": "https://www.bayvistaliving.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "361-301-2605",
  "custom_knock_lgp_number": "361-314-7121",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.bayvistaliving.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "361-304-9344",
  "custom_knock_psa_number": "361-314-2787",
  "custom_seo_subscription": "full_stack",
  "custom_knock_amap_number": "361-301-2769",
  "custom_knock_bandit_link": "https://www.bayvistaliving.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.bayvistaliving.com?utm_knock=flyers",
  "custom_knock_osoc_number": "361-314-2005",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321182085",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "361-301-2673",
  "custom_knock_cfres_number": "361-309-9792",
  "custom_knock_chatgpt_link": "https://www.bayvistaliving.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "e1c3a11eeb78d49e",
  "custom_knock_dirmail_link": "https://www.bayvistaliving.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "361-282-2706",
  "custom_knock_propbro_link": "https://www.bayvistaliving.com?utm_knock=propbro",
  "custom_knock_bandit_number": "361-304-3872",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "361-315-7322",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.bayvistaliving.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "361-733-3163",
  "custom_knock_dirmail_number": "361-315-6942",
  "custom_knock_propbro_number": "361-301-3272",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "361-301-2536",
  "custom_knock_maintenance_link": "https://www.bayvistaliving.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151192622/019e60d3-39c6-73e4-8629-8b64c6ed108f.mp4",
  "custom_knock_maintenance_number": "361-304-3847",
  "custom_ppc_tracking_phone_number": "361-348-8659"
};

export const generatedAt = '2026-10-07T17:14:17.265Z';
